import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import {
  callApi,
  fnGetDataSet,
  fnSave,
  fnGetTableById,
} from "@shared/api/restApi"; // BackEnd API
import {
  getTablebySql,
  getInitFormData,
  getNoSlip,
  toKeyMap,
  applySlip,
  CalAm,
} from "@shared/utils/CommonUtils";
import { showPopupModal } from "@widgets/CommonModal";
import { showDialog } from "@widgets/CommonDialog";
import { global, globalMenu } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid"; // 공통 그리드
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import { menuInfo } from "@shared/type/CommonType";
import SnButton from "@shared/components/SnButton";
import SnTab from "@shared/components/SnTab";
import SnTabHeader from "@shared/components/SnTabHeader";
import SnResizeBar from "@shared/components/SnResizeBar";
import SN_PRD_WRK_REG_002_TEX_POP_001 from "./SN_PRD_WRK_REG_002_TEX_POP_001";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import SN_PRD_WRK_REG_002_TEX_POP_002 from "./SN_PRD_WRK_REG_002_TEX_POP_002";
import SN_PRD_WRK_REG_002_TEX_POP_003 from "./SN_PRD_WRK_REG_002_TEX_POP_003";
import SN_PRD_WRK_REG_002_TEX_POP_004 from "./SN_PRD_WRK_REG_002_TEX_POP_004";
import { ColumnConfig } from "@shared/components/Grid/types";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

interface SizeMapValue {
  label: string;
  sort: number;
}

const SN_PRD_WRK_REG_002_TEX = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    grid3: React.createRef(),
  });
  const searchRef = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)

    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const { userInfo } = global();
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    sheet1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    sheet1: [],
  });
  const selectedTabPage = useRef<string>("1");
  const [tab, setTab] = useState<any>("1");
  const [gridFocus, setGridFocus] = useState(false);
  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [selectedLineDocu, setSelectedLineDocu] = useState<number>(0);
  const saveFocusTargetRef = useRef<{
    no_wo?: string;
    no_line_wo?: any;
  } | null>(null);
  const pendingFocusTargetRef = useRef<{
    no_wo?: string;
    no_line_wo?: any;
  } | null>(null);
  const sheetref1 = useRef<any>(null); // excel download 용
  const [sheet1Columns, setSheet1Columns] = useState<any[]>([]); // excel 업로드용 컬럼
  const cd_menu = Menuprops.cd_menu || "SN_PRD_WRK_REG_002_TEX";
  const sizeSlotColumns = Array.from(
    { length: 20 },
    (_, i) => `qt_work${i + 1}`
  );
  const ROW_TYPE = {
    ORDER: "수주",
    WORK: "실적",
    RATE: "비율",
  } as const;
  const PACK_ROW_TYPE = {
    TOTAL: "TOTAL",
    LOCATION: "LOCATION",
  } as const;
  const focusKeyRef = useRef<{
    no_wo?: string;
  } | null>(null);
  const cutLongRowsRef = useRef<any[]>([]);
  const packLongRowsRef = useRef<any[]>([]);
  const cutSizeSlotMapRef = useRef<Map<string, string[]>>(new Map());
  const packSizeSlotMapRef = useRef<Map<string, string[]>>(new Map());
  const sizeSortMapRef = useRef<Map<string, number>>(new Map());
  const SIZE_SORT_FALLBACK = 9999;
  const sizeCodeCollator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: "base",
  });

  const toFiniteNumber = (value: any, fallback = SIZE_SORT_FALLBACK) => {
    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : fallback;
  };

  const getSizeSort = (sizeKey: string, row?: any) => {
    const mapSort = sizeSortMapRef.current.get(sizeKey);
    if (mapSort !== undefined) return mapSort;
    return toFiniteNumber(row?.no_seq_sort);
  };

  const addSizeToMap = (sizeMap: Map<string, SizeMapValue>, row: any) => {
    const sizeKey = String(row.cd_var3 ?? "").trim();
    if (!sizeKey) return;
    const sizeLabel = String(row.nm_var3 ?? sizeKey).trim() || sizeKey;
    const sizeSort = getSizeSort(sizeKey, row);
    const current = sizeMap.get(sizeKey);
    if (!current || sizeSort < current.sort) {
      sizeMap.set(sizeKey, { label: sizeLabel, sort: sizeSort });
    }
  };

  const getSortedSizeList = (sizeMap: Map<string, SizeMapValue>) =>
    Array.from(sizeMap, ([key, value]) => ({
      key,
      label: value.label,
      sort: value.sort,
    })).sort((a, b) => {
      if (a.sort !== b.sort) return a.sort - b.sort;
      return sizeCodeCollator.compare(a.key, b.key);
    });

  const loadSizeSortMap = async () => {
    const rows = await getTablebySql({
      sql: `
        select cd_flag, no_seq_sort
          from snotes.mas_codel
         where cd_firm = :cd_firm
           and cd_clas = 'MAS168'
           and yn_use = 'Y'
         order by coalesce(no_seq_sort, 9999), cd_flag
      `,
      cd_firm: userInfo.cd_firm,
    });
    const nextMap = new Map<string, number>();
    (rows || []).forEach((row: any) => {
      const sizeKey = String(row.cd_flag ?? "").trim();
      if (!sizeKey) return;
      nextMap.set(sizeKey, toFiniteNumber(row.no_seq_sort));
    });
    sizeSortMapRef.current = nextMap;
  };

  const ensureSizeSortMap = async () => {
    if (sizeSortMapRef.current.size > 0) return;
    await loadSizeSortMap();
  };

  const visible = [
    { cd_column: "qt_work1", nm_column: "1", fg_visible: "N" },
    { cd_column: "qt_work2", nm_column: "2", fg_visible: "N" },
    { cd_column: "qt_work3", nm_column: "3", fg_visible: "N" },
    { cd_column: "qt_work4", nm_column: "4", fg_visible: "N" },
    { cd_column: "qt_work5", nm_column: "5", fg_visible: "N" },
    { cd_column: "qt_work6", nm_column: "6", fg_visible: "N" },
    { cd_column: "qt_work7", nm_column: "7", fg_visible: "N" },
    { cd_column: "qt_work8", nm_column: "8", fg_visible: "N" },
    { cd_column: "qt_work9", nm_column: "9", fg_visible: "N" },
    { cd_column: "qt_work10", nm_column: "10", fg_visible: "N" },
    { cd_column: "qt_work11", nm_column: "11", fg_visible: "N" },
    { cd_column: "qt_work12", nm_column: "12", fg_visible: "N" },
    { cd_column: "qt_work13", nm_column: "13", fg_visible: "N" },
    { cd_column: "qt_work14", nm_column: "14", fg_visible: "N" },
    { cd_column: "qt_work15", nm_column: "15", fg_visible: "N" },
    { cd_column: "qt_work16", nm_column: "16", fg_visible: "N" },
    { cd_column: "qt_work17", nm_column: "17", fg_visible: "N" },
    { cd_column: "qt_work18", nm_column: "18", fg_visible: "N" },
    { cd_column: "qt_work19", nm_column: "19", fg_visible: "N" },
    { cd_column: "qt_work20", nm_column: "20", fg_visible: "N" },
  ];
  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);

        //
        //  실적(row_type_flag=1)만 편집 허용하고, 신규 실적 숫자 항목만 수정 가능하도록
        const applyEditRules = (gridCols: ColumnConfig[]) =>
          gridCols.map((col) => {
            if (sizeSlotColumns.includes(col.cd_column)) {
              return {
                ...col,
                dc_editcon: "row_type_flag !== 1 || yn_saved_set === 1",
              };
            }
            return col;
          });

        const updatedColumns = rtn.grid.grid1.map((col: ColumnConfig) => {
          if (col.cd_column === "rt_loss") {
            // "퍼센트" 컬럼일 경우 우측 정렬
            return {
              ...col,
              cellClass: "custom-cell",
            };
          }
          return col;
        });

        setColums({
          grid1: updatedColumns,
          grid2: applyEditRules(rtn.grid.grid2),
          grid3: applyEditRules(rtn.grid.grid3),
          sheet1: rtn.grid.sheet1,
        });
        //setSheet1Columns(rtn.grid.sheet1);
      } catch (error) {}
    };
    fetchform();
  }, []);

  // useEffect(() => {
  //   grid1.current.selectAndFocusRow(0);
  //   setGridFocus(false);
  // }, [gridFocus]);

  useEffect(() => {}, [tab]);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onSave,
    onExcelUpload,
    onExcelDownLoad,
  }));
  //#region OnSearch

  //조회 조건으로 작업지시 목록을 불러오고, 캐시(롱포맷)와 그리드 데이터를 초기화한다.
  // 조회 전 변경내용이 있으면 저장 여부를 확인하고,
  // 승인되면 저장 후 현재 조건으로 작업지시/실적 데이터를 한 번만 조회한다.
  // 조회 결과는 FE에서 피벗 캐시를 다시 구성해 하단 그리드에 반영한다.
  const onSearch = async (focusTarget?: {
    no_wo?: string;
    no_line_wo?: any;
  }) => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    const modifiedRowsL2 = gridRefs.current["grid3"].current.getChange();

    // 🔥 TOTAL row 제거
    modifiedRowsL2.insert = modifiedRowsL2.insert.filter(
      (row: any) =>
        row.nm_dummy01 !== "TOTAL" && row.row_type !== PACK_ROW_TYPE.TOTAL
    );
    modifiedRowsL2.update = modifiedRowsL2.update.filter(
      (row: any) =>
        row.nm_dummy01 !== "TOTAL" && row.row_type !== PACK_ROW_TYPE.TOTAL
    );

    modifiedRowsL2.modifiedRowcount =
      modifiedRowsL2.insert.length + modifiedRowsL2.update.length;
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0 ||
      modifiedRowsL2.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const checkSave: any = onSave();
        if (!checkSave) {
          return;
        }
      }
    }
    try {
      await loadSizeSortMap();

      const params = {
        id: "sn_prd_wrk_reg_002_tex_01",
        params: searchRef.current.getFormdata(),
      };

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      setSelectedDocu("");

      const data: any = await fnGetDataSet(params);

      setDataSources({
        grid1: data[0],
        grid2: [],
        grid3: [],
        sheet1: data[3] || [],
      });
      cutLongRowsRef.current = data[1] || [];
      packLongRowsRef.current = data[2] || [];
      if (focusTarget?.no_wo) {
        pendingFocusTargetRef.current = focusTarget;
      } else {
        pendingFocusTargetRef.current = null;
      }
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const focusGrid1ByTarget = (target?: { no_wo?: string }) => {
    const grid1Ref = gridRefs.current["grid1"].current;
    if (!grid1Ref) return false;
    const targetNoWo = String(target?.no_wo ?? "").trim();
    if (!targetNoWo) {
      grid1Ref.selectAndFocusRow(0);
      return true;
    }
    let targetIndex = -1;
    grid1Ref.forEachFilteredNode((node: any) => {
      if (targetIndex !== -1) return;
      const nodeNoWo = String(node.data?.no_wo ?? "").trim();
      if (nodeNoWo !== targetNoWo) return;
      targetIndex = node.rowIndex;
    });
    if (targetIndex >= 0) {
      grid1Ref.selectAndFocusRow(targetIndex);
      return true;
    }
    return false;
  };

  // 롱포맷 데이터를 작업세트 단위로 묶어 수주/실적/비율 3행 피벗을 만든다.
  const buildPivotRows = ({
    rows,
    includeLocation,
    sizeSlotMapRef,
  }: {
    rows: any[];
    includeLocation: boolean;
    sizeSlotMapRef: React.MutableRefObject<Map<string, string[]>>;
  }) => {
    //  롱포맷 결과에 일부 row_type이 누락되면 3행 구조가 깨져 화면/저장 흐름이 불안정해진다.
    //  피벗 변환 시 기준키별로 지시/실적/비율 3행을 항상 고정 생성한다.
    //  pivotKey별로 누락 행을 보완하고, 저장 여부 플래그를 함께 내려준다.
    const sizeMap = new Map<string, SizeMapValue>();
    rows.forEach((row) => {
      addSizeToMap(sizeMap, row);
    });

    const sizeList = getSortedSizeList(sizeMap);
    const sizeToSlot = new Map<string, string>();
    const slotLabelByColumn = new Map<string, string>();
    sizeList.slice(0, sizeSlotColumns.length).forEach((size, index) => {
      sizeToSlot.set(size.key, sizeSlotColumns[index]);
      slotLabelByColumn.set(sizeSlotColumns[index], size.label);
    });

    const groupedRows = new Map<string, any>();
    const baseByPivotKey = new Map<string, any>();
    const pivotKeyByRowKey = new Map<string, string>();
    const savedByPivotKey = new Map<string, boolean>();

    // 세트/row_type 단위로 기본 행을 만들고 슬롯 합계를 채운다.
    const createPivotRow = (
      baseRow: any,
      rowType: string,
      pivotKey: string
    ) => {
      const rowTypeFlag = includeLocation
        ? rowType === PACK_ROW_TYPE.LOCATION
          ? 1
          : 0
        : rowType === ROW_TYPE.WORK
          ? 1
          : rowType === ROW_TYPE.RATE
            ? 2
            : 0;
      const isHeaderRow = includeLocation
        ? rowTypeFlag === 1
        : rowType === ROW_TYPE.ORDER;
      const pivotRow: Record<string, any> = {
        cd_firm: baseRow.cd_firm,
        cd_biz: baseRow.cd_biz,
        no_wo: baseRow.no_wo,
        no_line_wo: baseRow.no_line_wo,
        no_work: baseRow.no_work ?? "",
        dt_work: isHeaderRow ? baseRow.dt_work : "",
        cd_op: baseRow.cd_op,
        cd_gp: baseRow.cd_gp,
        cd_emp: isHeaderRow ? baseRow.cd_emp : "",
        nm_emp: isHeaderRow ? baseRow.nm_emp : "",
        dt_wo: baseRow.dt_wo,
        no_style: baseRow.no_style,
        cd_item: baseRow.cd_item,
        cd_var1: baseRow.cd_var1,
        cd_var2: baseRow.cd_var2,
        cd_dummy01: baseRow.cd_dummy01,
        nm_dummy01: baseRow.nm_dummy01,
        row_type: rowType,
        row_type_flag: rowTypeFlag,
        work_set_id: baseRow.work_set_id ?? baseRow.no_work ?? "",
        sort_no_work: baseRow.no_work ?? "",
        qt_b: baseRow.qt_b ?? 0,
      };
      sizeSlotColumns.forEach((slot) => {
        pivotRow[slot] = 0;
      });
      if (!sizeSlotMapRef.current.has(pivotKey)) {
        sizeSlotMapRef.current.set(
          pivotKey,
          sizeList.slice(0, sizeSlotColumns.length).map((item) => item.key)
        );
      }
      return pivotRow;
    };

    // no_work가 비어있으면 work_set_id로 세트 키를 유지한다.
    rows.forEach((row) => {
      const keyParts = [
        row.no_wo ?? "",
        row.no_line_wo ?? "",
        row.no_style ?? "",
        row.cd_item ?? "",
        row.cd_var1 ?? "",
        row.cd_var2 ?? "",
      ];
      if (includeLocation) {
        keyParts.push(row.cd_dummy01 ?? "");
      }
      const workSetKey =
        String(row.no_work ?? "").trim() ||
        String(row.work_set_id ?? "").trim();
      keyParts.push(workSetKey);
      const pivotKey = keyParts.join("|");
      const rowType = includeLocation
        ? String(row.cd_dummy01 ?? "")
            .trim()
            .toUpperCase() === "TOTAL"
          ? PACK_ROW_TYPE.TOTAL
          : PACK_ROW_TYPE.LOCATION
        : (row.row_type ?? "");
      const rowKey = `${pivotKey}|${rowType}`;
      pivotKeyByRowKey.set(rowKey, pivotKey);
      if (!baseByPivotKey.has(pivotKey)) {
        baseByPivotKey.set(pivotKey, row);
      }
      if (String(row.no_work ?? "").trim()) {
        savedByPivotKey.set(pivotKey, true);
      }

      let pivotRow = groupedRows.get(rowKey);
      if (!pivotRow) {
        pivotRow = createPivotRow(row, rowType, pivotKey);
        groupedRows.set(rowKey, pivotRow);
      }

      const slot = sizeToSlot.get(String(row.cd_var3 ?? "").trim());
      if (slot) {
        pivotRow[slot] = Number(pivotRow[slot] ?? 0) + Number(row.qt_val ?? 0);
      }
    });

    const rowTypeOrder = includeLocation
      ? [PACK_ROW_TYPE.TOTAL, PACK_ROW_TYPE.LOCATION]
      : [ROW_TYPE.ORDER, ROW_TYPE.WORK, ROW_TYPE.RATE];
    if (!includeLocation) {
      baseByPivotKey.forEach((baseRow, pivotKey) => {
        rowTypeOrder.forEach((rowType) => {
          const rowKey = `${pivotKey}|${rowType}`;
          if (groupedRows.has(rowKey)) return;
          pivotKeyByRowKey.set(rowKey, pivotKey);
          groupedRows.set(rowKey, createPivotRow(baseRow, rowType, pivotKey));
        });
      });
    }
    if (!includeLocation) {
      baseByPivotKey.forEach((_, pivotKey) => {
        const orderRow = groupedRows.get(`${pivotKey}|${ROW_TYPE.ORDER}`);
        const workRow = groupedRows.get(`${pivotKey}|${ROW_TYPE.WORK}`);
        const rateRow = groupedRows.get(`${pivotKey}|${ROW_TYPE.RATE}`);

        if (!orderRow || !workRow || !rateRow) return;

        // 슬롯별 비율
        sizeSlotColumns.forEach((slot) => {
          const orderVal = Number(orderRow[slot] || 0);
          const workVal = Number(workRow[slot] || 0);

          rateRow[slot] =
            orderVal === 0
              ? 0
              : Number((((workVal - orderVal) / orderVal) * 100).toFixed(2));
        });

        // 🔥 총합 비율 (여기 추가)
        const orderTotal = sizeSlotColumns.reduce(
          (sum, slot) => sum + Number(orderRow[slot] || 0),
          0
        );

        const workTotal = sizeSlotColumns.reduce(
          (sum, slot) => sum + Number(workRow[slot] || 0),
          0
        );

        rateRow.qt_work =
          orderTotal === 0
            ? 0
            : Number(Math.round(((workTotal - orderTotal) / orderTotal) * 100));
      });
    }
    groupedRows.forEach((pivotRow, rowKey) => {
      const pivotKey = pivotKeyByRowKey.get(rowKey) ?? "";
      pivotRow.yn_saved_set = savedByPivotKey.get(pivotKey) ? 1 : 0;

      // 🔥 RATE는 sum 계산하지 않음
      if (!includeLocation && pivotRow.row_type === ROW_TYPE.RATE) {
        return;
      }
      pivotRow.qt_work = sizeSlotColumns.reduce(
        (sum, slot) => sum + Number(pivotRow[slot] || 0),
        0
      );
    });

    const pivotRows: any[] = [];
    if (includeLocation) {
      groupedRows.forEach((row) => {
        pivotRows.push(row);
      });
    } else {
      baseByPivotKey.forEach((_baseRow, pivotKey) => {
        rowTypeOrder.forEach((rowType) => {
          const rowKey = `${pivotKey}|${rowType}`;
          const row = groupedRows.get(rowKey);
          if (row) pivotRows.push(row);
        });
      });
    }

    return {
      pivotRows,
      slotLabelByColumn,
    };
  };

  // 사이즈 슬롯(qt_work1~20)의 표시 여부와 헤더 라벨을 피벗 결과에 맞춰 갱신한다.
  const buildSizeColumnUpdates = (
    gridColumns: any[],
    slotLabelByColumn: Map<string, string>
  ) => {
    const virtual: any[] = [];
    gridColumns.forEach((row: any) => {
      if (row.cd_column && sizeSlotColumns.includes(row.cd_column)) {
        const slotLabel = slotLabelByColumn.get(row.cd_column);
        virtual.push({
          nm_header: "Size",
          cd_column: row.cd_column,
          nm_column: slotLabel ?? row.nm_column,
          fg_visible: slotLabel ? "Y" : "N",
          yn_sum: "Y",
        });
      }
    });
    return virtual;
  };

  // 실적번호 → FIT → COLOR 순으로 정렬해 화면 표시 순서를 고정한다.
  const sortPivotRows = (rows: any[]) => {
    // 정렬용 문자열 비교를 단순화.
    const compareText = (a: any, b: any) =>
      String(a ?? "").localeCompare(String(b ?? ""));
    const isPackRow = (row: any) =>
      String(row.row_type ?? "").toUpperCase() === PACK_ROW_TYPE.TOTAL ||
      String(row.row_type ?? "").toUpperCase() === PACK_ROW_TYPE.LOCATION;
    const getPackGroupKey = (row: any) =>
      [
        row.no_wo ?? "",
        row.no_line_wo ?? "",
        row.no_style ?? "",
        row.cd_item ?? "",
        row.cd_var1 ?? "",
        row.cd_var2 ?? "",
      ].join("|");
    return [...rows].sort((a, b) => {
      const aIsPack = isPackRow(a);
      const bIsPack = isPackRow(b);
      if (aIsPack || bIsPack) {
        const byBase = compareText(getPackGroupKey(a), getPackGroupKey(b));
        if (byBase !== 0) return byBase;
        const aIsTotal =
          String(a.row_type ?? "").toUpperCase() === PACK_ROW_TYPE.TOTAL ||
          String(a.cd_dummy01 ?? "").toUpperCase() === "TOTAL";
        const bIsTotal =
          String(b.row_type ?? "").toUpperCase() === PACK_ROW_TYPE.TOTAL ||
          String(b.cd_dummy01 ?? "").toUpperCase() === "TOTAL";
        if (aIsTotal !== bIsTotal) return aIsTotal ? -1 : 1;
        const aSetKey = String(
          a.sort_no_work ?? a.no_work ?? a.work_set_id ?? ""
        ).trim();
        const bSetKey = String(
          b.sort_no_work ?? b.no_work ?? b.work_set_id ?? ""
        ).trim();
        const bySetKey = compareText(aSetKey, bSetKey);
        if (bySetKey !== 0) return bySetKey;
        const byLocation = compareText(a.cd_dummy01, b.cd_dummy01);
        if (byLocation !== 0) return byLocation;
        return 0;
      }
      const aSetKey = String(
        a.sort_no_work ?? a.no_work ?? a.work_set_id ?? ""
      ).trim();
      const bSetKey = String(
        b.sort_no_work ?? b.no_work ?? b.work_set_id ?? ""
      ).trim();
      if (aSetKey === "" && bSetKey !== "") return 1;
      if (aSetKey !== "" && bSetKey === "") return -1;
      const bySetKey = compareText(aSetKey, bSetKey);
      if (bySetKey !== 0) return bySetKey;
      const byFit = compareText(a.cd_var1, b.cd_var1);
      if (byFit !== 0) return byFit;
      const byColor = compareText(a.cd_var2, b.cd_var2);
      if (byColor !== 0) return byColor;
      const aIsTotal =
        String(a.row_type ?? "").toUpperCase() === PACK_ROW_TYPE.TOTAL ||
        String(a.cd_dummy01 ?? "").toUpperCase() === "TOTAL";
      const bIsTotal =
        String(b.row_type ?? "").toUpperCase() === PACK_ROW_TYPE.TOTAL ||
        String(b.cd_dummy01 ?? "").toUpperCase() === "TOTAL";
      if (aIsTotal !== bIsTotal) return aIsTotal ? -1 : 1;
      const byLocation = compareText(a.cd_dummy01, b.cd_dummy01);
      if (byLocation !== 0) return byLocation;
      return Number(a.row_type_flag ?? 0) - Number(b.row_type_flag ?? 0);
    });
  };

  // 현재 그리드 컬럼 설정에 사이즈 슬롯 라벨/표시 상태를 반영한다.
  const applySizeColumnState = (
    gridKey: "grid2" | "grid3",
    slotLabelByColumn: Map<string, string>
  ) => {
    setColums((prev: any) => {
      const updated = prev[gridKey].map((col: any) => {
        if (!col.cd_column || !sizeSlotColumns.includes(col.cd_column)) {
          return col;
        }
        const slotLabel = slotLabelByColumn.get(col.cd_column);
        return {
          ...col,
          nm_column: slotLabel ?? col.nm_column,
          fg_visible: slotLabel ? "Y" : "N",
          yn_sum: "Y",
        };
      });
      return { ...prev, [gridKey]: updated };
    });
  };

  // 현재 탭(재단/포장)에 보이는 피벗 그리드를 그대로 엑셀로 내려받는다.
  const getExcelContextMenuItems = (params: any) => {
    const defaultItems = params.defaultItems ?? [];
    const filtered = defaultItems.filter((item: any) => item !== "export");
    return [
      ...filtered,
      "separator",
      {
        name: "내보내기",
        subMenu: [
          {
            name: "Excel 내보내기",
            action: () => onExcelDownLoad(),
          },
          {
            name: "CSV 내보내기",
            action: () => params.api.exportDataAsCsv(),
          },
        ],
      },
    ];
  };

  const onExcelDownLoad = async () => {
    try {
      const rows: any[] = [];
      const virtual: any[] = [];
      const gridKey = selectedTabPage.current === "1" ? "grid2" : "grid3";
      const gridRef = gridRefs.current[gridKey].current;

      const displayedCols = gridRef?.getAllDisplayedColumns?.() || [];
      const formatterByColId = new Map<string, any>();
      const colDefById = new Map<string, any>();
      displayedCols.forEach((col: any) => {
        const colId = col.getColId?.() || col.colId || col.field;
        if (!colId) return;
        const headerName =
          col.getColDef?.()?.headerName ?? col.headerName ?? colId;
        const colDef = col.getColDef?.() ?? {};
        if (colDef.valueFormatter) {
          formatterByColId.set(colId, colDef.valueFormatter);
          colDefById.set(colId, colDef);
        }
        virtual.push({
          cd_column: colId,
          nm_column: headerName,
          fg_visible: "Y",
        });
      });
      sheetref1.current.changeColumnConfigs(virtual);
      gridRef?.forEachFilteredNode((node: any) => {
        if (node?.data) rows.push(node.data);
      });
      // 2) sheetref1 초기화 후 주입 (⚠ SnGrid는 setRowData 없음)
      sheetref1.current?.deleteAllRows?.(); // SnGrid가 제공하는 삭제 헬퍼
      sheetref1.current?.applyTransaction({
        add: rows.map((r) => ({ ...r })), // 깊은 복사 권장
      });

      // 3) “보이는 컬럼만” export 키 생성 (숨김 제외)
      const sheetDisplayedCols =
        sheetref1.current?.getAllDisplayedColumns() || [];
      const columnKeys = sheetDisplayedCols.map((c: any) => c.getColId());

      const getHeaderUpper = (colDef: any, params: any) => {
        const headerName =
          colDef?.headerName ?? params.column?.getColDef?.()?.headerName ?? "";
        return String(headerName).trim().toUpperCase();
      };
      const getLocationLabel = (row: any) => {
        const loc = row?.nm_dummy01 ?? row?.cd_dummy01;
        return loc !== undefined && loc !== null && loc !== ""
          ? loc
          : undefined;
      };
      const getFitColorFallback = (
        row: any,
        headerUpper: string,
        value: any
      ) =>
        headerUpper === "FIT"
          ? (row?.cd_var1 ?? value)
          : (row?.cd_var2 ?? value);

      const today = new Date();
      const formattedDate = today.toISOString().slice(0, 10).replace(/-/g, "");
      const formattedTime = today.toTimeString().slice(0, 8).replace(/:/g, "");

      // 4) Excel Export: processCellCallback으로 “라벨 우선” 매핑
      sheetref1.current?.exportDataAsExcel({
        columnKeys,
        skipPinnedBottom: true,
        fileName: `${globalMenu.getState().activeMenuInfo.nm_menu}_DownLoad_${formattedDate}${formattedTime}.xlsx`,

        sheetName: "Sheet1",
        processCellCallback: (params: any) => {
          const colId = params.column?.getColId?.() ?? "";
          const formatter = formatterByColId.get(colId);
          const colDef = colDefById.get(colId) ?? params.column?.getColDef?.();
          let value = params.value;
          if (colDef?.valueGetter) {
            try {
              value = colDef.valueGetter({
                value,
                data: params.node?.data,
                node: params.node,
                colDef,
                column: params.column,
                api: params.api,
                columnApi: params.columnApi,
                context: params.context,
              });
            } catch (error) {}
          }
          const headerUpper = getHeaderUpper(colDef, params);
          if (headerUpper === "LOCATION" || colId === "cd_dummy01") {
            const loc = getLocationLabel(params.node?.data);
            if (loc !== undefined) return loc;
          }
          if (
            (headerUpper === "FIT" || headerUpper === "COLOR") &&
            (value === undefined || value === null || value === "")
          ) {
            return getFitColorFallback(params.node?.data, headerUpper, value);
          }
          if (headerUpper === "구분" && value === PACK_ROW_TYPE.LOCATION) {
            const loc = getLocationLabel(params.node?.data);
            if (loc !== undefined) return loc;
          }
          const cellRenderer = colDef?.cellRenderer;
          if (typeof cellRenderer === "function") {
            const rendered = cellRenderer({
              value,
              data: params.node?.data,
              node: params.node,
              colDef,
              column: params.column,
              api: params.api,
              columnApi: params.columnApi,
              context: params.context,
            });
            if (typeof rendered === "string" || typeof rendered === "number") {
              return rendered;
            }
          }
          if (!formatter) return value;
          const formatted = formatter({
            value,
            data: params.node?.data,
            node: params.node,
            colDef,
          });
          return formatted ?? value;
        },
        // onExcelDownLoad 내부 exportDataAsExcel({...})의 processCellCallback 만 교체
      });
    } catch (e: any) {
      showDialog("error", e?.message || "Excel 다운로드 오류");
    }
  };

  // 피벗 행을 식별하기 위한 고유 키를 만든다.
  const getPivotRowKey = (row: any, includeLocation: boolean) => {
    const baseKey = getBaseKey(row, includeLocation);
    const noWork = String(row?.no_work ?? "").trim();
    const rowType = String(row?.row_type ?? "").trim();
    return `${baseKey}|${noWork}|${rowType}`;
  };

  // 엑셀 업로드 결과를 그리드에 적용한다. (insert-only 또는 매칭 업데이트)
  const applySheetRowsToGrid = (
    sheetRows: any[],
    gridKey: "grid2" | "grid3",
    includeLocation: boolean,
    forceInsert: boolean
  ) => {
    const gridRef = gridRefs.current[gridKey]?.current;
    if (!gridRef) return;
    if (forceInsert) {
      sheetRows.forEach((row: any) => {
        const newRow = { ...row };
        delete newRow.KeyField;
        newRow.no_work = "";
        newRow.back_no_work = "";
        newRow.back_dt_work = undefined;
        newRow.back_cd_emp = undefined;
        newRow.back_cd_var1 = undefined;
        newRow.back_cd_var2 = undefined;
        newRow.yn_saved_set = 0;
        gridRef.addRow?.(newRow);
      });
      return;
    }
    const nodeByKey = new Map<string, any>();
    gridRef.forEachFilteredNode((node: any) => {
      nodeByKey.set(getPivotRowKey(node.data, includeLocation), node);
    });
    sheetRows.forEach((row: any) => {
      const key = getPivotRowKey(row, includeLocation);
      const node = nodeByKey.get(key);
      if (!node) {
        gridRef.addRow?.(row);
        return;
      }
      if (row.row_type === ROW_TYPE.ORDER) {
        if (row.dt_work !== undefined) {
          node.setDataValue("dt_work", row.dt_work);
        }
        if (row.cd_emp !== undefined) {
          node.setDataValue("cd_emp", row.cd_emp);
        }
        if (row.nm_emp !== undefined) {
          node.setDataValue("nm_emp", row.nm_emp);
        }
      }
      sizeSlotColumns.forEach((slot) => {
        if (row[slot] !== undefined) {
          node.setDataValue(slot, row[slot]);
        }
      });
    });
  };

  // 엑셀 업로드 팝업용 컬럼을 만들고, 실적 행만 수정 가능하도록 제한한다.
  const buildModalColumns = (
    gridColumns: any[],
    slotLabelByColumn: Map<string, string>
  ) =>
    gridColumns.map((col: any) => {
      if (!col.cd_column || !sizeSlotColumns.includes(col.cd_column)) {
        return col;
      }
      const slotLabel = slotLabelByColumn.get(col.cd_column);
      return {
        ...col,
        nm_column: slotLabel ?? col.nm_column,
        fg_visible: slotLabel ? "Y" : "N",
        dc_editcon: "row_type_flag !== 1",
      };
    });

  // 엑셀 업로드용 신규 피벗 세트를 롱포맷 기준으로 생성한다.
  const buildExcelRows = (
    includeLocation: boolean,
    sizeSlotMapRef: React.MutableRefObject<Map<string, string[]>>
  ) => {
    const selectedRows = gridRefs.current["grid1"].current.focusedRowNode();
    const gridKey = includeLocation ? "grid3" : "grid2";
    const gridRef = gridRefs.current[gridKey].current;
    //  기존 실적이 있을 때 엑셀 업로드가 기존 피벗을 그대로 보여준다.
    //  엑셀 업로드는 항상 신규 세트(0값)로 시작한다.
    //  그리드 현행 데이터는 사용하지 않고 롱포맷 기준으로 피벗을 생성한다.
    const longRows = (
      includeLocation ? packLongRowsRef.current : cutLongRowsRef.current
    ).filter((row: any) => {
      if (row.no_wo !== selectedRows?.data?.no_wo) return false;
      if (
        selectedRows?.data?.no_line_wo &&
        row.no_line_wo !== selectedRows?.data?.no_line_wo
      )
        return false;
      return true;
    });

    const baseRows = new Map<string, any>();
    longRows.forEach((row: any) => {
      if (includeLocation) {
        if (
          String(row.cd_dummy01 ?? "")
            .trim()
            .toUpperCase() !== "TOTAL"
        )
          return;
      } else if (row.row_type !== ROW_TYPE.ORDER) {
        return;
      }
      const key = getBaseKey(row, false);
      if (!baseRows.has(key)) {
        baseRows.set(key, row);
      }
    });

    if (baseRows.size === 0) {
      showDialog("alter", "추가할 기준 데이터가 없습니다.");
      return null;
    }

    //  헤더 기반 사이즈 매핑은 초기 상태에서 누락 발생한다.
    //  롱포맷(order row)의 cd_var3/nm_var3 기준으로 슬롯을 구성한다.
    //  order row에서 사이즈 목록을 만들고 슬롯 라벨을 채운다.
    const rows: any[] = [];
    const slotLabelByColumn = new Map<string, string>();
    const sizeMap = new Map<string, SizeMapValue>();
    longRows.forEach((row: any) => {
      if (includeLocation) {
        if (
          String(row.cd_dummy01 ?? "")
            .trim()
            .toUpperCase() !== "TOTAL"
        )
          return;
      } else if (row.row_type !== ROW_TYPE.ORDER) {
        return;
      }
      addSizeToMap(sizeMap, row);
    });
    const sizeList = getSortedSizeList(sizeMap);
    sizeList.slice(0, sizeSlotColumns.length).forEach((size, index) => {
      slotLabelByColumn.set(sizeSlotColumns[index], size.label);
    });

    baseRows.forEach((baseRow) => {
      const baseKey = getBaseKey(baseRow, false);
      if (includeLocation) {
        const newSet = buildPackSetRows({
          baseRow,
          longRows,
          sizeSlotMapRef,
        });
        newSet.baseKeys.forEach((key: string) => {
          if (!sizeSlotMapRef.current.get(`${key}|`)) {
            sizeSlotMapRef.current.set(`${key}|`, newSet.sizeCodes);
          }
        });
        rows.push(...newSet.rows);
        return;
      }
      const newSet = buildNewSetRows({
        baseRow,
        includeLocation,
        longRows,
        cdOp: "T210",
        sizeSlotMapRef,
      });
      const sizeCodes = newSet.sizeCodes;
      if (!sizeSlotMapRef.current.get(`${baseKey}|`)) {
        sizeSlotMapRef.current.set(`${baseKey}|`, sizeCodes);
      }
      rows.push(...newSet.rows);
    });

    if (rows.length === 0) {
      showDialog("alter", "추가할 기준 데이터가 없습니다.");
      return null;
    }

    const resolvedSlotLabels =
      slotLabelByColumn.size > 0
        ? slotLabelByColumn
        : new Map<string, string>();
    return { rows, slotLabelByColumn: resolvedSlotLabels };
  };

  // 엑셀 업로드용 신규 행을 insert-only 형태로 정규화한다.
  const normalizeExcelInsertRows = (rows: any[], batchId: string) =>
    rows.map((row) => ({
      ...row,
      no_work: "",
      back_no_work: "",
      back_dt_work: undefined,
      back_cd_emp: undefined,
      back_cd_var1: undefined,
      back_cd_var2: undefined,
      yn_saved_set: 0,
      __excel_batch_id: batchId,
    }));

  // 엑셀 업로드 실패 시 배치로 추가된 행만 되돌린다.
  const rollbackExcelBatch = (gridKey: "grid2" | "grid3", batchId: string) => {
    const gridRef = gridRefs.current[gridKey].current;
    const deleteIndexes: number[] = [];
    gridRef.forEachFilteredNode((node: any) => {
      if (node.data?.__excel_batch_id === batchId) {
        deleteIndexes.push(node.rowIndex);
      }
    });
    deleteIndexes
      .sort((a, b) => b - a)
      .forEach((rowIndex) => gridRef.deleteRowByIndex?.(rowIndex));
  };

  // 업로드 성공 후 배치 마커를 제거한다.
  const clearExcelBatchMarker = (
    gridKey: "grid2" | "grid3",
    batchId: string
  ) => {
    const gridRef = gridRefs.current[gridKey].current;
    gridRef.forEachFilteredNode((node: any) => {
      if (node.data?.__excel_batch_id === batchId) {
        delete node.data.__excel_batch_id;
      }
    });
  };

  const onExcelUpload = async () => {
    //  엑셀 업로드 실패 시 임시 세트가 남아 중복 입력이 발생한다.
    //  잔량 검증 후에만 insert하고, 저장 실패 시 즉시 롤백한다.
    //  배치 마커로 insert-only 세트를 추적해 성공 시 유지/실패 시 삭제한다.
    const isCut = selectedTabPage.current === "1";
    const excelData = buildExcelRows(
      !isCut,
      isCut ? cutSizeSlotMapRef : packSizeSlotMapRef
    );
    if (!excelData) return;
    const cols = buildModalColumns(
      isCut ? columns.grid2 : columns.grid3,
      excelData.slotLabelByColumn
    );
    const label = isCut ? "재단" : "포장";
    const component = (
      <SN_PRD_WRK_REG_002_TEX_POP_002
        Menuprops={Menuprops}
        title={`엑셀 업로드 (${label})`}
        columns={cols}
        rows={excelData.rows}
        onApply={async (editedRows: any[]) => {
          const checkRows = editedRows.filter(
            (row: any) =>
              row.row_type === ROW_TYPE.WORK || row.row_type_flag === 1
          );
          const pendingChanges = {
            insert: checkRows,
            update: [],
            delete: [],
          };
          /*const hasLimitError = isCut
            ? validateWorkLimitsWithPending(pendingChanges, true)
            : validatePackLimitsWithPending(editedRows);
          if (hasLimitError) {
            const confirm = await showDialog("confirm", hasLimitError);
            if (!confirm) return false;
          }*/

          const batchId = `excel_${Date.now()}`;
          const insertRows = normalizeExcelInsertRows(editedRows, batchId);
          const gridKey = isCut ? "grid2" : "grid3";
          applySheetRowsToGrid(insertRows, gridKey, !isCut, true);
          const saved = await onSave();
          if (!saved) {
            rollbackExcelBatch(gridKey, batchId);
            return false;
          }
          clearExcelBatchMarker(gridKey, batchId);
          return true;
        }}
      />
    );
    await showPopupModal({
      title: "엑셀 업로드",
      children: component,
      width: "90%",
      height: "90VH",
      okayBtnText: "저장",
    });
  };
  //#region OnDeleteRow
  // 선택된 세트(실적번호 기준)만 삭제한다. 같은 FIT/COLOR라도 다른 세트는 skip.
  const onDeleteRow = async () => {
    if (
      gridRefs.current["grid2"].current?.getDisplayedRowCount() < 0 ||
      gridRefs.current["grid3"].current?.getDisplayedRowCount() < 0
    ) {
      return;
    }

    const gridKey = selectedTabPage.current === "1" ? "grid2" : "grid3";
    const gridRef = gridRefs.current[gridKey].current;
    const focusedNode = gridRef.focusedRowNode?.();
    const focusedData = Array.isArray(focusedNode)
      ? focusedNode[0]?.data
      : focusedNode?.data;
    if (!focusedData) return;

    const payload = {
      id: "taxl_no_rcv",
      params: {
        cd_firm: userInfo.cd_firm,
        no_rcv: focusedData.work_set_id ?? focusedData.no_work,
      },
    };
    const no_rcv = await fnGetTableById(payload);
    if (no_rcv.length > 0) {
      const error = await showDialog("error", "외주매입 등록된 건입니다.");
      if (!error) return;
    }

    const includeLocation = gridKey === "grid3";
    if (includeLocation) {
      const isLocationRow =
        focusedData.row_type === PACK_ROW_TYPE.LOCATION ||
        focusedData.row_type_flag === 1;
      if (!isLocationRow) {
        showDialog("alter", "포장실적 행만 삭제할 수 있습니다.");
        return;
      }
      const payload = {
        id: "qtioh_no_io",
        params: {
          cd_firm: userInfo.cd_firm,
          no_io: (focusedData.work_set_id ?? focusedData.no_work).concat("_B"),
        },
      };
      const workvariantb_tex = await fnGetTableById(payload);
      if (workvariantb_tex.length > 0) {
        const error = await showDialog(
          "error",
          "불량내역을 먼저 삭제해 주세요"
        );
        if (!error) return;
      }
    } else {
      const payload = {
        id: "qtioh_no_io",
        params: {
          cd_firm: userInfo.cd_firm,
          no_io: focusedData.work_set_id ?? focusedData.no_work,
        },
      };
      const workvariantb_tex = await fnGetTableById(payload);
      if (workvariantb_tex.length > 0) {
        const error = await showDialog(
          "error",
          "소요자재를 먼저 삭제해 주세요."
        );
        if (!error) return;
      }
    }
    const targetBaseKey = getBaseKey(focusedData, includeLocation);
    let targetSetKey = String(
      focusedData.work_set_id ?? focusedData.no_work ?? ""
    ).trim();
    if (!targetSetKey) {
      gridRef.forEachFilteredNode((node: any) => {
        if (
          getBaseKey(node.data, includeLocation) === targetBaseKey &&
          (node.data?.work_set_id || node.data?.no_work)
        ) {
          targetSetKey = String(
            node.data.work_set_id ?? node.data.no_work ?? ""
          ).trim();
        }
      });
    }
    const hasTargetSetKey = !!targetSetKey;
    const nodesToDelete: any[] = [];
    gridRef.forEachFilteredNode((node: any) => {
      const nodeSetKey = String(
        node.data?.work_set_id ?? node.data?.no_work ?? ""
      ).trim();
      if (hasTargetSetKey) {
        if (nodeSetKey === targetSetKey) {
          nodesToDelete.push(node);
        }
        return;
      }
      if (getBaseKey(node.data, includeLocation) !== targetBaseKey) return;
      nodesToDelete.push(node);
    });

    if (gridKey === "grid3") {
      const hasQtB = nodesToDelete.some(
        (node) => Number(node.data?.qt_b ?? 0) !== 0
      );
    }

    const deleteIndexes = nodesToDelete
      .map((node: any) => node.rowIndex)
      .filter((index: any) => typeof index === "number")
      .sort((a: number, b: number) => b - a);
    deleteIndexes.forEach((index: number) => {
      gridRef.deleteRowByIndex?.(index);
    });
  };

  // 작업세트를 묶기 위한 기본 키(no_wo/var1/var2 등)를 만든다.
  const getBaseKey = (row: any, includeLocation: boolean) => {
    const keyParts = [
      row.no_wo ?? "",
      row.no_line_wo ?? "",
      row.no_style ?? "",
      row.cd_item ?? "",
      row.cd_var1 ?? "",
      row.cd_var2 ?? "",
    ];
    if (includeLocation) {
      keyParts.push(row.cd_dummy01 ?? "");
    }
    return keyParts.join("|");
  };

  // 특정 row_type의 사이즈 슬롯 합계를 baseKey별로 집계한다.
  const sumSlotsByRowType = (
    gridRef: React.RefObject<any>,
    rowType: string,
    includeLocation: boolean
  ) => {
    const sums = new Map<string, number[]>();
    gridRef.current.forEachFilteredNode((node: any) => {
      if (node.data.row_type !== rowType) return;
      const key = getBaseKey(node.data, includeLocation);
      const slotSums =
        sums.get(key) ??
        Array.from({ length: sizeSlotColumns.length }, () => 0);
      sizeSlotColumns.forEach((slot, index) => {
        slotSums[index] += Number(node.data[slot] || 0);
      });
      sums.set(key, slotSums);
    });
    return sums;
  };

  // 지시(row_type=ORDER)의 슬롯 수량을 baseKey별로 비교 기준으로 만든다.
  const sumOrderSlotsByBaseKey = (
    gridRef: React.RefObject<any>,
    includeLocation: boolean
  ) => {
    const sums = new Map<string, number[]>();
    gridRef.current.forEachFilteredNode((node: any) => {
      if (node.data.row_type !== ROW_TYPE.ORDER) return;
      const key = getBaseKey(node.data, includeLocation);
      const slotMax =
        sums.get(key) ??
        Array.from({ length: sizeSlotColumns.length }, () => 0);
      sizeSlotColumns.forEach((slot, index) => {
        const value = Number(node.data[slot] || 0);
        if (value > slotMax[index]) {
          slotMax[index] = value;
        }
      });
      sums.set(key, slotMax);
    });
    return sums;
  };

  // 롱포맷 데이터에서 슬롯 합계를 만들어 잔량 검증에 사용한다.
  const buildLongRowSlotSums = (
    rows: any[],
    rowType: string,
    includeLocation: boolean,
    sizeSlotMapRef: React.MutableRefObject<Map<string, string[]>>
  ) => {
    const sizeIndexByBase = new Map<string, Map<string, number>>();
    // 사이즈 코드를 슬롯 인덱스로 매핑하는 기준을 만든다.
    const ensureSizeIndex = (baseKey: string) => {
      if (sizeIndexByBase.has(baseKey)) {
        return sizeIndexByBase.get(baseKey)!;
      }
      let sizeCodes = sizeSlotMapRef.current.get(`${baseKey}|`) ?? [];
      if (sizeCodes.length === 0) {
        const sizeMap = new Map<string, SizeMapValue>();
        rows.forEach((row: any) => {
          if (row.row_type !== ROW_TYPE.ORDER) return;
          if (getBaseKey(row, includeLocation) !== baseKey) return;
          addSizeToMap(sizeMap, row);
        });
        sizeCodes = getSortedSizeList(sizeMap).map((item) => item.key);
        if (sizeCodes.length > 0) {
          sizeSlotMapRef.current.set(`${baseKey}|`, sizeCodes);
        }
      }
      const indexMap = new Map<string, number>();
      sizeCodes.slice(0, sizeSlotColumns.length).forEach((code, index) => {
        indexMap.set(code, index);
      });
      sizeIndexByBase.set(baseKey, indexMap);
      return indexMap;
    };
    const sums = new Map<string, number[]>();
    rows.forEach((row: any) => {
      if (row.row_type !== rowType) return;
      const baseKey = getBaseKey(row, includeLocation);
      const indexMap = ensureSizeIndex(baseKey);
      const sizeCode = String(row.cd_var3 ?? "").trim();
      const index = indexMap.get(sizeCode);
      if (index === undefined) return;
      const slotSums =
        sums.get(baseKey) ??
        Array.from({ length: sizeSlotColumns.length }, () => 0);
      slotSums[index] += Number(row.qt_val ?? 0);
      sums.set(baseKey, slotSums);
    });
    return sums;
  };

  // 저장 시점 잔량 체크: 재단은 지시수량 기준, 포장은 재단실적 기준으로 제한한다.
  const validateWorkLimits = () => {
    // 잔량 검증은 저장 시점에 기존 실적과 신규 실적을 합산 기준으로 판단해야 한다.
    // 실적(row_type=WORK)만 합산해 지시/재단 대비 초과 여부를 확인한다.
    // 현재 그리드 상태(기존+신규)를 기준으로 슬롯 합계를 비교한다.
    const orderSums = sumOrderSlotsByBaseKey(gridRefs.current["grid2"], false);
    const cutWorkSums = sumSlotsByRowType(
      gridRefs.current["grid2"],
      ROW_TYPE.WORK,
      false
    );
    /*
    let work = 0,
      order = 0;
    let flag = false;
    for (const [key, workSlots] of cutWorkSums.entries()) {
      const orderSlots =
        orderSums.get(key) ??
        Array.from({ length: sizeSlotColumns.length }, () => 0);
      for (let i = 0; i < sizeSlotColumns.length; i += 1) {
        if (workSlots[i] > orderSlots[i]) {
          work += workSlots[i];
          order += orderSlots[i];
          flag = true;
        }
      }
    }
   if (flag) {
      return (
        "재단 실적 수량이 수주수량을 초과합니다. \n 저장하시겠습니까? \n\n 수주수량: " +
        order +
        " \n 실적수량: " +
        work +
        ""
      );
    }
    let cut = 0,
      pack = 0;
    flag = false;
    const packWorkSums = sumSlotsByRowType(
      gridRefs.current["grid3"],
      ROW_TYPE.WORK,
      true
    );
    for (const [key, packSlots] of packWorkSums.entries()) {
      const cutSlots =
        cutWorkSums.get(key) ??
        Array.from({ length: sizeSlotColumns.length }, () => 0);
      for (let i = 0; i < sizeSlotColumns.length; i += 1) {
        if (packSlots[i] > cutSlots[i]) {
          cut += cutSlots[i];
          pack += packSlots[i];
          flag = true;
        }
      }
    }
    if (flag) {
      return (
        "포장 실적 수량이 재단 실적 수량을 초과합니다. \n 저장하시겠습니까? \n\n 재단 실적수량: " +
        cut +
        "\n 포장 실적수량: " +
        pack +
        ""
      );
    }
      */
    return "";
  };

  const validatePackLimits = () => {
    const packLocationSums = sumSlotsByRowType(
      gridRefs.current["grid3"],
      PACK_ROW_TYPE.LOCATION,
      false
    );
    const packTotalSums = sumSlotsByRowType(
      gridRefs.current["grid3"],
      PACK_ROW_TYPE.TOTAL,
      false
    );
    /*let cut = 0,
      pack = 0;
    let flag = false;
    for (const [key, packSlots] of packLocationSums.entries()) {
      const totalSlots =
        packTotalSums.get(key) ??
        Array.from({ length: sizeSlotColumns.length }, () => 0);
      for (let i = 0; i < sizeSlotColumns.length; i += 1) {
        if (packSlots[i] > totalSlots[i]) {
          cut += totalSlots[i];
          pack += packSlots[i];
          flag = true;
        }
      }
    }
    if (flag) {
      return (
        "포장 실적 수량이 재단 실적 수량을 초과합니다. \n 저장하시겠습니까? \n\n 재단 실적수량: " +
        cut +
        "\n포장 실적수량: " +
        pack +
        ""
      );
    }*/
    return "";
  };

  const validatePackLimitsWithPending = (pendingRows: any[]) => {
    const baseMap = sumSlotsByRowType(
      gridRefs.current["grid3"],
      PACK_ROW_TYPE.LOCATION,
      false
    );
    const pendingLocationRows = pendingRows.filter(
      (row: any) =>
        row.row_type === PACK_ROW_TYPE.LOCATION || row.row_type_flag === 1
    );
    const pendingTotalRows = pendingRows.filter((row: any) => {
      const dummy = String(row.cd_dummy01 ?? "")
        .trim()
        .toUpperCase();
      return row.row_type === PACK_ROW_TYPE.TOTAL || dummy === "TOTAL";
    });

    pendingLocationRows.forEach((row: any) => {
      const key = getBaseKey(row, false);
      const slotSums =
        baseMap.get(key) ??
        Array.from({ length: sizeSlotColumns.length }, () => 0);
      sizeSlotColumns.forEach((slot, index) => {
        slotSums[index] += Number(row[slot] || 0);
      });
      baseMap.set(key, slotSums);
    });

    const totalMap = sumSlotsByRowType(
      gridRefs.current["grid3"],
      PACK_ROW_TYPE.TOTAL,
      false
    );
    const pendingTotalMap = new Map<string, number[]>();
    pendingTotalRows.forEach((row: any) => {
      const key = getBaseKey(row, false);
      const slotSums =
        pendingTotalMap.get(key) ??
        Array.from({ length: sizeSlotColumns.length }, () => 0);
      sizeSlotColumns.forEach((slot, index) => {
        slotSums[index] += Number(row[slot] || 0);
      });
      pendingTotalMap.set(key, slotSums);
    });
    pendingTotalMap.forEach((slots, key) => {
      totalMap.set(key, slots);
    });
    /*let cut = 0,
      pack = 0;
    let flag = false;
    for (const [key, packSlots] of baseMap.entries()) {
      const totalSlots =
        totalMap.get(key) ??
        Array.from({ length: sizeSlotColumns.length }, () => 0);
      for (let i = 0; i < sizeSlotColumns.length; i += 1) {
        if (packSlots[i] > totalSlots[i]) {
          cut += totalSlots[i];
          pack += packSlots[i];
          flag = true;
        }
      }
    }
    if (flag) {
      return (
        "포장 실적 수량이 재단 실적 수량을 초과합니다. \n 저장하시겠습니까? \n\n 재단 실적수량: " +
        cut +
        "\n포장 실적수량: " +
        pack +
        ""
      );
    }*/
    return "";
  };

  // 엑셀 업로드 잔량 체크: 기존 실적을 포함하되 중복 합산은 제외한다.
  const validateWorkLimitsWithPending = (
    pending: { insert?: any[]; update?: any[]; delete?: any[] },
    isCut: boolean
  ) => {
    //  잔량 검증 시 실적 외 행이 포함되면 초과 판단이 왜곡된다.
    //  실적(row_type=WORK)만 합산하고, 기존 실적과 신규 실적을 합산한다.
    //  pending 실적 행만 슬롯 합계에 반영한다.
    const includeLocation = false;
    const workRowType = isCut ? ROW_TYPE.WORK : PACK_ROW_TYPE.LOCATION;
    const baseMap = sumSlotsByRowType(
      gridRefs.current[isCut ? "grid2" : "grid3"],
      workRowType,
      includeLocation
    );
    //  엑셀 업로드로 기존 실적을 수정할 때 중복 합산되어 초과로 판단된다.
    //  동일 세트(no_work)의 기존 실적을 먼저 제외한 뒤 업로드 값을 반영한다.
    //  baseKey+no_work 기준으로 기존 합계를 차감 후 pending 값을 더한다.
    const existingBySet = new Map<string, number[]>();
    const gridKey = isCut ? "grid2" : "grid3";
    gridRefs.current[gridKey].current.forEachFilteredNode((node: any) => {
      const row = node.data;
      if (isCut) {
        if (row.row_type !== ROW_TYPE.WORK) return;
      } else {
        if (row.row_type !== PACK_ROW_TYPE.LOCATION && row.row_type_flag !== 1)
          return;
      }
      const baseKey = getBaseKey(row, includeLocation);
      const noWork = String(row.no_work ?? "").trim();
      if (!noWork) return;
      const key = `${baseKey}|${noWork}`;
      const slotSums =
        existingBySet.get(key) ??
        Array.from({ length: sizeSlotColumns.length }, () => 0);
      sizeSlotColumns.forEach((slot, index) => {
        slotSums[index] += Number(row[slot] || 0);
      });
      existingBySet.set(key, slotSums);
    });
    const processedSetKeys = new Set<string>();

    (pending.insert ?? []).forEach((row: any) => {
      if (isCut) {
        if (row.row_type !== ROW_TYPE.WORK) {
          return;
        }
      } else {
        if (
          row.row_type !== PACK_ROW_TYPE.LOCATION &&
          row.row_type_flag !== 1
        ) {
          return;
        }
      }
      const key = getBaseKey(row, includeLocation);
      const noWork = String(row.no_work ?? "").trim();
      const setKey = noWork ? `${key}|${noWork}` : "";
      const slotSums =
        baseMap.get(key) ??
        Array.from({ length: sizeSlotColumns.length }, () => 0);
      if (setKey && !processedSetKeys.has(setKey)) {
        const existingSlots = existingBySet.get(setKey);
        if (existingSlots) {
          sizeSlotColumns.forEach((slot, index) => {
            slotSums[index] -= Number(existingSlots[index] || 0);
          });
        }
        processedSetKeys.add(setKey);
      }
      sizeSlotColumns.forEach((slot, index) => {
        slotSums[index] += Number(row[slot] || 0);
      });
      baseMap.set(key, slotSums);
    });
    /*
    if (isCut) {
      const orderSums = sumOrderSlotsByBaseKey(
        gridRefs.current["grid2"],
        false
      );
      const longOrderSums = buildLongRowSlotSums(
        cutLongRowsRef.current,
        ROW_TYPE.ORDER,
        false,
        cutSizeSlotMapRef
      );

      let work = 0,
        order = 0;
      let flag = false;
      for (const [key, workSlots] of baseMap.entries()) {
        if (!orderSums.has(key) && longOrderSums.has(key)) {
          orderSums.set(key, longOrderSums.get(key) as number[]);
        }
        const orderSlots =
          orderSums.get(key) ??
          Array.from({ length: sizeSlotColumns.length }, () => 0);
        for (let i = 0; i < sizeSlotColumns.length; i += 1) {
          if (workSlots[i] > orderSlots[i]) {
            work += workSlots[i];
            order += orderSlots[i];
            flag = true;
          }
        }
      }
      if (flag) {
        return (
          "재단 실적 수량이 수주수량을 초과합니다. \n 저장하시겠습니까? \n\n 수주수량: " +
          order +
          " \n 실적수량: " +
          work +
          ""
        );
      }
      return "";
    }

    if (!isCut) {
      return "";
    }

    const cutWorkSums = sumSlotsByRowType(
      gridRefs.current["grid2"],
      ROW_TYPE.WORK,
      false
    );
    const longCutWorkSums = buildLongRowSlotSums(
      cutLongRowsRef.current,
      ROW_TYPE.WORK,
      false,
      cutSizeSlotMapRef
    );
    let cut = 0,
      pack = 0;
    let flag = false;
    for (const [key, packSlots] of baseMap.entries()) {
      if (!cutWorkSums.has(key) && longCutWorkSums.has(key)) {
        cutWorkSums.set(key, longCutWorkSums.get(key) as number[]);
      }
      const cutSlots =
        cutWorkSums.get(key) ??
        Array.from({ length: sizeSlotColumns.length }, () => 0);
      for (let i = 0; i < sizeSlotColumns.length; i += 1) {
        if (packSlots[i] > cutSlots[i]) {
          cut += cutSlots[i];
          pack += packSlots[i];
          flag = true;
        }
      }
    }
    if (flag) {
      return (
        "포장 실적 수량이 재단 실적 수량을 초과합니다. \n 저장하시겠습니까? \n\n 재단 실적수량: " +
        cut +
        "\n포장 실적수량: " +
        pack +
        ""
      );
    }
      */
    return "";
  };

  // 아직 저장되지 않은 신규 세트가 있는지 확인한다.
  const hasPendingNewSet = (gridRef: React.RefObject<any>) => {
    let hasPending = false;
    gridRef.current.forEachFilteredNode((node: any) => {
      const workSetId = String(node.data?.work_set_id ?? "").trim();
      if (!workSetId.startsWith("TMP_")) return;
      if (String(node.data?.no_work ?? "").trim()) return;
      hasPending = true;
    });
    return hasPending;
  };

  // 선택된 기준으로 신규 세트(지시/실적/비율)를 생성한다.
  const buildNewSetRows = ({
    baseRow,
    includeLocation,
    longRows,
    cdOp,
    sizeSlotMapRef,
    forcedSizeCodes,
  }: {
    baseRow: any;
    includeLocation: boolean;
    longRows: any[];
    cdOp: string;
    sizeSlotMapRef: React.MutableRefObject<Map<string, string[]>>;
    forcedSizeCodes?: string[];
  }) => {
    const workSetId = `TMP_${Date.now()}_${Math.random()
      .toString(36)
      .slice(2, 8)}`;
    const matchRows = longRows.filter((row) => {
      if (row.no_wo !== baseRow.no_wo) return false;
      if (baseRow.no_line_wo && row.no_line_wo !== baseRow.no_line_wo)
        return false;
      if (row.no_style !== baseRow.no_style) return false;
      if (row.cd_item !== baseRow.cd_item) return false;
      if (row.cd_var1 !== baseRow.cd_var1) return false;
      if (row.cd_var2 !== baseRow.cd_var2) return false;
      if (includeLocation && row.cd_dummy01 !== baseRow.cd_dummy01)
        return false;
      return row.row_type === ROW_TYPE.ORDER;
    });

    const sizeMap = new Map<string, SizeMapValue>();
    matchRows.forEach((row) => {
      addSizeToMap(sizeMap, row);
    });

    const sizeList = getSortedSizeList(sizeMap);
    const baseKey = getBaseKey(baseRow, includeLocation);
    let existingSizeCodes: string[] = [];
    sizeSlotMapRef.current.forEach((codes, key) => {
      if (!key.startsWith(`${baseKey}|`)) return;
      if (codes.length > existingSizeCodes.length) {
        existingSizeCodes = codes;
      }
    });
    const finalSizeCodes =
      forcedSizeCodes && forcedSizeCodes.length > 0
        ? forcedSizeCodes
        : existingSizeCodes.length >= sizeList.length
          ? existingSizeCodes
          : sizeList.map((item) => item.key);
    const finalSizeList = finalSizeCodes.map((key) => ({
      key,
      label: sizeMap.get(key)?.label ?? key,
    }));
    const sizeToSlot = new Map<string, string>();
    const slotLabelByColumn = new Map<string, string>();
    finalSizeList.slice(0, sizeSlotColumns.length).forEach((size, index) => {
      sizeToSlot.set(size.key, sizeSlotColumns[index]);
      slotLabelByColumn.set(sizeSlotColumns[index], size.label);
    });

    const baseFields = {
      cd_firm: baseRow.cd_firm ?? userInfo.cd_firm,
      cd_biz: userInfo.cd_biz,
      no_wo: baseRow.no_wo,
      no_line_wo: baseRow.no_line_wo,
      no_work: "",
      dt_work: "",
      cd_op: cdOp,
      cd_gp: userInfo.cd_gp,
      cd_emp: "",
      nm_emp: "",
      cd_wh: "",
      dt_wo: baseRow.dt_wo,
      no_style: baseRow.no_style,
      cd_item: baseRow.cd_item,
      cd_var1: baseRow.cd_var1,
      cd_var2: baseRow.cd_var2,
      cd_dummy01: includeLocation ? baseRow.cd_dummy01 : undefined,
      nm_dummy01: includeLocation
        ? (baseRow.nm_dummy01 ?? baseRow.cd_dummy01)
        : undefined,
      qt_b: 0,
      yn_saved_set: 0,
      work_set_id: workSetId,
    };

    // 신규 세트에 들어갈 기본 행 초기화.
    const initRow = (rowType: string): Record<string, any> => {
      const rowTypeFlag =
        rowType === ROW_TYPE.WORK ? 1 : rowType === ROW_TYPE.RATE ? 2 : 0;
      const isHeaderRow = rowType === ROW_TYPE.ORDER;
      const row: Record<string, any> = {
        ...baseFields,
        row_type: rowType,
        row_type_flag: rowTypeFlag,
        dt_work: isHeaderRow ? todayform : "",
        cd_emp: isHeaderRow ? userInfo.cd_emp : "",
        nm_emp: isHeaderRow ? userInfo.nm_emp : "",
        cd_wh: "",
        qt_work: 0,
      };
      sizeSlotColumns.forEach((slot) => {
        row[slot] = 0;
      });
      return row;
    };

    const orderRow = initRow(ROW_TYPE.ORDER);
    matchRows.forEach((row) => {
      const slot = sizeToSlot.get(String(row.cd_var3 ?? "").trim());
      if (slot) {
        orderRow[slot] = Number(row.qt_val ?? 0);
      }
    });

    const workRow = initRow(ROW_TYPE.WORK);

    const rateRow = initRow(ROW_TYPE.RATE);
    sizeSlotColumns.forEach((slot) => {
      const orderValue = Number(orderRow[slot] || 0);
      const workValue = Number(workRow[slot] || 0);
      rateRow[slot] =
        orderValue > 0
          ? Math.round(((workValue - orderValue) * 100) / orderValue)
          : 0;
    });

    const sizeCodes = finalSizeList
      .slice(0, sizeSlotColumns.length)
      .map((item) => item.key);

    return {
      rows: [orderRow, workRow, rateRow],
      slotLabelByColumn,
      sizeCodes,
    };
  };

  const buildPackSetRows = ({
    baseRow,
    longRows,
    sizeSlotMapRef,
  }: {
    baseRow: any;
    longRows: any[];
    sizeSlotMapRef: React.MutableRefObject<Map<string, string[]>>;
  }) => {
    const workSetId = `TMP_${Date.now()}_${Math.random()
      .toString(36)
      .slice(2, 8)}`;
    const isSameBase = (row: any) => {
      if (row.no_wo !== baseRow.no_wo) return false;
      if (baseRow.no_line_wo && row.no_line_wo !== baseRow.no_line_wo)
        return false;
      if (row.no_style !== baseRow.no_style) return false;
      if (row.cd_item !== baseRow.cd_item) return false;
      if (row.cd_var1 !== baseRow.cd_var1) return false;
      if (row.cd_var2 !== baseRow.cd_var2) return false;
      return true;
    };

    const totalRows = longRows.filter(
      (row) =>
        isSameBase(row) &&
        String(row.cd_dummy01 ?? "")
          .trim()
          .toUpperCase() === "TOTAL"
    );
    const locationRows = longRows.filter(
      (row) =>
        isSameBase(row) &&
        String(row.cd_dummy01 ?? "")
          .trim()
          .toUpperCase() !== "TOTAL" &&
        String(row.cd_dummy01 ?? "").trim() !== ""
    );

    const sizeMap = new Map<string, SizeMapValue>();
    totalRows.forEach((row) => {
      addSizeToMap(sizeMap, row);
    });
    const sizeList = getSortedSizeList(sizeMap);
    const sizeToSlot = new Map<string, string>();
    sizeList.slice(0, sizeSlotColumns.length).forEach((size, index) => {
      sizeToSlot.set(size.key, sizeSlotColumns[index]);
    });
    const baseFields = {
      cd_firm: baseRow.cd_firm ?? userInfo.cd_firm,
      cd_biz: userInfo.cd_biz,
      no_wo: baseRow.no_wo,
      no_line_wo: baseRow.no_line_wo,
      no_work: "",
      dt_work: "",
      cd_op: "T220",
      cd_gp: userInfo.cd_gp,
      cd_emp: "",
      nm_emp: "",
      cd_wh: "",
      dt_wo: baseRow.dt_wo,
      no_style: baseRow.no_style,
      cd_item: baseRow.cd_item,
      cd_var1: baseRow.cd_var1,
      cd_var2: baseRow.cd_var2,
      qt_b: 0,
      yn_saved_set: 0,
      work_set_id: workSetId,
    };

    const initRow = (
      rowType: string,
      location: { cd_dummy01: string; nm_dummy01?: string }
    ): Record<string, any> => {
      const isLocation = rowType === PACK_ROW_TYPE.LOCATION;
      const row: Record<string, any> = {
        ...baseFields,
        row_type: rowType,
        row_type_flag: isLocation ? 1 : 0,
        cd_dummy01: location.cd_dummy01,
        nm_dummy01: location.nm_dummy01 ?? location.cd_dummy01,
        dt_work: isLocation ? todayform : (baseRow.dt_work ?? ""),
        cd_emp: isLocation ? userInfo.cd_emp : (baseRow.cd_emp ?? ""),
        nm_emp: isLocation ? userInfo.nm_emp : (baseRow.nm_emp ?? ""),
        qt_work: 0,
      };
      sizeSlotColumns.forEach((slot) => {
        row[slot] = 0;
      });
      return row;
    };

    const totalDisplayName =
      String(baseRow.row_type ?? "").trim() || baseRow.nm_dummy01 || "TOTAL";
    const totalRow = initRow(PACK_ROW_TYPE.TOTAL, {
      cd_dummy01: "TOTAL",
      nm_dummy01: totalDisplayName,
    });
    totalRows.forEach((row) => {
      const slot = sizeToSlot.get(String(row.cd_var3 ?? "").trim());
      if (slot) {
        totalRow[slot] = Number(row.qt_val ?? 0);
      }
    });
    totalRow.qt_work = sizeSlotColumns.reduce(
      (sum, slot) => sum + Number(totalRow[slot] || 0),
      0
    );

    const locationMap = new Map<
      string,
      { cd_dummy01: string; nm_dummy01?: string }
    >();
    locationRows.forEach((row) => {
      const code = String(row.cd_dummy01 ?? "").trim();
      if (!code) return;
      if (!locationMap.has(code)) {
        locationMap.set(code, {
          cd_dummy01: code,
          nm_dummy01: row.nm_dummy01 ?? code,
        });
      }
    });
    const locationList = Array.from(locationMap.values());

    const rows = [totalRow];
    const baseKeys = [getBaseKey(totalRow, true)];
    locationList.forEach((loc) => {
      const row = initRow(PACK_ROW_TYPE.LOCATION, loc);
      rows.push(row);
      baseKeys.push(getBaseKey(row, true));
    });

    const sizeCodes = sizeList
      .slice(0, sizeSlotColumns.length)
      .map((item) => item.key);
    return { rows, sizeCodes, baseKeys };
  };

  // 남은 수량이 있는지(지시-실적) 판단한다. 행추가 가능여부 판단에 사용된다.
  const hasRemainingQty = (
    baseRow: any,
    rows: any[],
    includeLocation: boolean
  ) => {
    let hasRemaining = false;
    if (includeLocation) {
      const totalBySize = new Map<string, number>();
      const locationBySize = new Map<string, number>();

      rows.forEach((row: any) => {
        if (row.no_wo !== baseRow.no_wo) return;
        if (baseRow.no_line_wo && row.no_line_wo !== baseRow.no_line_wo) return;
        if (row.no_style !== baseRow.no_style) return;
        if (row.cd_item !== baseRow.cd_item) return;
        if (row.cd_var1 !== baseRow.cd_var1) return;
        if (row.cd_var2 !== baseRow.cd_var2) return;
        const sizeKey = String(row.cd_var3 ?? "").trim();
        if (!sizeKey) return;

        if (
          String(row.cd_dummy01 ?? "")
            .trim()
            .toUpperCase() === "TOTAL"
        ) {
          totalBySize.set(
            sizeKey,
            Number(totalBySize.get(sizeKey) || 0) + Number(row.qt_val || 0)
          );
          return;
        }
        locationBySize.set(
          sizeKey,
          Number(locationBySize.get(sizeKey) || 0) + Number(row.qt_val || 0)
        );
      });

      totalBySize.forEach((totalQty, sizeKey) => {
        const workQty = Number(locationBySize.get(sizeKey) || 0);
        if (totalQty - workQty > 0) {
          hasRemaining = true;
        }
      });
      return hasRemaining;
    }
    const orderBySize = new Map<string, number>();
    const workBySize = new Map<string, number>();

    rows.forEach((row: any) => {
      if (row.no_wo !== baseRow.no_wo) return;
      if (baseRow.no_line_wo && row.no_line_wo !== baseRow.no_line_wo) return;
      if (row.no_style !== baseRow.no_style) return;
      if (row.cd_item !== baseRow.cd_item) return;
      if (row.cd_var1 !== baseRow.cd_var1) return;
      if (row.cd_var2 !== baseRow.cd_var2) return;
      if (includeLocation && row.cd_dummy01 !== baseRow.cd_dummy01) return;
      const sizeKey = String(row.cd_var3 ?? "").trim();
      if (!sizeKey) return;

      if (row.row_type === ROW_TYPE.ORDER) {
        const nextValue = Number(row.qt_val || 0);
        const current = Number(orderBySize.get(sizeKey) || 0);
        if (nextValue > current) {
          orderBySize.set(sizeKey, nextValue);
        }
      }
      if (row.row_type === ROW_TYPE.WORK) {
        workBySize.set(
          sizeKey,
          Number(workBySize.get(sizeKey) || 0) + Number(row.qt_val || 0)
        );
      }
    });

    orderBySize.forEach((orderQty, sizeKey) => {
      const workQty = Number(workBySize.get(sizeKey) || 0);
      if (orderQty - workQty > 0) {
        hasRemaining = true;
      }
    });

    return hasRemaining;
  };

  // 선택된 작업지시 기준으로 신규 세트를 3행(지시/실적/비율)로 추가한다.
  //#region onAddRow
  const onAddRow = async () => {
    gridRefs.current["grid1"].current?.stopEditing();
    const selectedRows = gridRefs.current["grid1"].current.focusedRowNode();
    try {
      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }
      if (!selectedRows?.data) {
        showDialog("alter", "작업지시를 선택해 주세요.");
        return;
      }
      await ensureSizeSortMap();

      if (selectedTabPage.current === "1") {
        if (hasPendingNewSet(gridRefs.current["grid2"])) {
          showDialog(
            "alter",
            "저장 전 신규 세트가 있습니다. 저장 후 추가해 주세요."
          );
          return;
        }

        const longRows = cutLongRowsRef.current.filter((row: any) => {
          if (row.no_wo !== selectedRows.data?.no_wo) return false;
          if (
            selectedRows.data?.no_line_wo &&
            row.no_line_wo !== selectedRows.data?.no_line_wo
          )
            return false;
          return true;
        });
        const baseRows = new Map<string, any>();
        longRows.forEach((row: any) => {
          if (row.row_type !== ROW_TYPE.ORDER) return;
          const key = getBaseKey(row, false);
          if (!baseRows.has(key)) {
            baseRows.set(key, row);
          }
        });

        if (baseRows.size === 0) {
          showDialog("alter", "추가할 기준 데이터가 없습니다.");
          return;
        }

        const globalSizeMap = new Map<string, SizeMapValue>();
        longRows.forEach((row: any) => {
          if (row.row_type !== ROW_TYPE.ORDER) return;
          addSizeToMap(globalSizeMap, row);
        });
        const globalSizeList = getSortedSizeList(globalSizeMap);
        const globalSlotLabelByColumn = new Map<string, string>();
        const globalSizeCodes: string[] = [];
        globalSizeList
          .slice(0, sizeSlotColumns.length)
          .forEach((size, index) => {
            const slot = sizeSlotColumns[index];
            globalSlotLabelByColumn.set(slot, size.label);
            globalSizeCodes.push(size.key);
          });
        if (globalSlotLabelByColumn.size > 0) {
          const virtual = buildSizeColumnUpdates(
            columns.grid2,
            globalSlotLabelByColumn
          );
          applySizeColumnState("grid2", globalSlotLabelByColumn);
          gridRefs.current["grid2"].current.changeColumnConfigs(virtual);
        }
        const newSets: Array<{
          baseRow: any;
          newSet: {
            rows: any[];
            slotLabelByColumn: Map<string, string>;
            sizeCodes: string[];
          };
        }> = [];
        baseRows.forEach((baseRow) => {
          const newSet = buildNewSetRows({
            baseRow,
            includeLocation: false,
            longRows,
            cdOp: "T210",
            sizeSlotMapRef: cutSizeSlotMapRef,
            forcedSizeCodes: globalSizeCodes,
          });
          newSets.push({ baseRow, newSet });
        });
        let addedCount = 0;
        newSets.forEach(({ baseRow, newSet }) => {
          if (!hasRemainingQty(baseRow, longRows, false)) return;
          const baseKey = getBaseKey(baseRow, false);
          const sizeCodes =
            globalSizeCodes.length > 0 ? globalSizeCodes : newSet.sizeCodes;
          cutSizeSlotMapRef.current.set(`${baseKey}|`, sizeCodes);
          newSet.rows.forEach((row: any) => {
            gridRefs.current["grid2"].current?.addRow(row);
          });
          addedCount += 1;
        });
        if (addedCount === 0) {
          showDialog("alter", "추가할 기준 데이터가 없습니다.");
          return;
        }
      } else if (selectedTabPage.current === "2") {
        if (hasPendingNewSet(gridRefs.current["grid3"])) {
          showDialog(
            "alter",
            "저장 전 신규 세트가 있습니다. 저장 후 추가해 주세요."
          );
          return;
        }

        const longRows = packLongRowsRef.current.filter((row: any) => {
          if (row.no_wo !== selectedRows.data?.no_wo) return false;
          if (
            selectedRows.data?.no_line_wo &&
            row.no_line_wo !== selectedRows.data?.no_line_wo
          )
            return false;
          return true;
        });
        const baseRows = new Map<string, any>();
        longRows.forEach((row: any) => {
          if (
            String(row.cd_dummy01 ?? "")
              .trim()
              .toUpperCase() !== "TOTAL"
          )
            return;
          const key = getBaseKey(row, false);
          if (!baseRows.has(key)) {
            baseRows.set(key, row);
          }
        });
        if (baseRows.size === 0) {
          showDialog("alter", "포장 Location 기준 데이터가 없습니다.");
          return;
        }

        const globalSizeMap = new Map<string, SizeMapValue>();
        longRows.forEach((row: any) => {
          if (
            String(row.cd_dummy01 ?? "")
              .trim()
              .toUpperCase() !== "TOTAL"
          )
            return;
          addSizeToMap(globalSizeMap, row);
        });
        const globalSizeList = getSortedSizeList(globalSizeMap);
        const globalSlotLabelByColumn = new Map<string, string>();
        const globalSizeCodes: string[] = [];
        globalSizeList
          .slice(0, sizeSlotColumns.length)
          .forEach((size, index) => {
            const slot = sizeSlotColumns[index];
            globalSlotLabelByColumn.set(slot, size.label);
            globalSizeCodes.push(size.key);
          });
        if (globalSlotLabelByColumn.size > 0) {
          const virtual = buildSizeColumnUpdates(
            columns.grid3,
            globalSlotLabelByColumn
          );
          applySizeColumnState("grid3", globalSlotLabelByColumn);
          gridRefs.current["grid3"].current.changeColumnConfigs(virtual);
        }
        const newSets: Array<{
          baseRow: any;
          newSet: {
            rows: any[];
            sizeCodes: string[];
            baseKeys: string[];
          };
        }> = [];
        baseRows.forEach((baseRow) => {
          const newSet = buildPackSetRows({
            baseRow,
            longRows,
            sizeSlotMapRef: packSizeSlotMapRef,
          });
          newSets.push({ baseRow, newSet });
        });
        let addedCount = 0;
        newSets.forEach(({ baseRow, newSet }) => {
          if (!hasRemainingQty(baseRow, longRows, true)) return;
          if (newSet.rows.length < 2) return;
          const sizeCodes =
            globalSizeCodes.length > 0 ? globalSizeCodes : newSet.sizeCodes;
          newSet.baseKeys.forEach((key: string) => {
            packSizeSlotMapRef.current.set(`${key}|`, sizeCodes);
          });
          newSet.rows.forEach((row: any) => {
            gridRefs.current["grid3"].current?.addRow(row);
          });
          addedCount += 1;
        });
        if (addedCount === 0) {
          showDialog("alter", "추가할 기준 데이터가 없습니다.");
          return;
        }
      }
    } catch (error: any) {}
  };

  //#region OnSave

  // 변경된 실적을 롱포맷으로 변환해 저장하고, 저장 후 재조회로 화면을 동기화한다.
  const onSave = async () => {
    let grid2,
      grid3,
      SaveData: any = {},
      no_slip;
    try {
      const grid1Ref = gridRefs.current["grid1"].current;
      const selectedRows = grid1Ref?.getSelectedRows?.() || [];
      const selectedRow =
        selectedRows.length > 0
          ? selectedRows[0]
          : grid1Ref?.focusedRowNode?.()?.data;
      const focusNoWo = selectedDocu || selectedRow?.no_wo;
      saveFocusTargetRef.current = focusNoWo ? { no_wo: focusNoWo } : null;
      gridRefs.current["grid2"].current.stopEditing();
      gridRefs.current["grid3"].current.stopEditing();
      await new Promise((resolve) => setTimeout(resolve, 0));
      grid2 = gridRefs.current["grid2"].current.getChange();
      grid3 = gridRefs.current["grid3"].current.getChange();
      const isCut = selectedTabPage.current === "1";
      let grid2Required = true;
      if (isCut) {
        const { filtered: newGrid2, hasRequired } = filterAndMapGrid(
          grid2,
          cutSizeSlotMapRef,
          false,
          gridRefs.current["grid2"]
        );
        grid2 = newGrid2;
        grid2Required = hasRequired;
      } else {
        grid2 = { insert: [], update: [], delete: [], modifiedRowcount: 0 };
      }
      if (isCut) {
        grid3 = { insert: [], update: [], delete: [], modifiedRowcount: 0 };
      }

      const grid2DeleteCount = grid2.delete?.length ?? 0;
      const grid3DeleteCount = grid3.delete?.length ?? 0;
      const changeCount =
        grid2.modifiedRowcount +
        grid3.modifiedRowcount +
        grid2DeleteCount +
        grid3DeleteCount;
      if (changeCount < 1) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      if (false && grid2.modifiedRowcount < 1 && grid3.modifiedRowcount < 1) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      if (isCut && !grid2Required) {
        showDialog("alter", "필수값이 누락되었습니다.");
        return;
      }
      let grid3Required = true;
      if (!isCut) {
        const { filtered: newGrid3, hasRequired } = filterAndMapGrid3(
          grid3,
          packSizeSlotMapRef,
          true,
          gridRefs.current["grid3"]
        );
        grid3 = newGrid3;
        grid3Required = hasRequired;
      } else {
        grid3 = { insert: [], update: [], delete: [], modifiedRowcount: 0 };
      }
      if (false && grid3.modifiedRowcount < 1 && grid2.modifiedRowcount < 1) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      if (!isCut && !grid3Required) {
        showDialog("alter", "필수값이 누락되었습니다.");
        return;
      }

      const limitError = isCut ? validateWorkLimits() : validatePackLimits();
      if (limitError) {
        const confirm = await showDialog("confirm", limitError);
        if (!confirm) return false;
      }

      if (!isCut) {
        const grid3Api = gridRefs.current["grid3"].current;
        const allGrid3Rows: any[] = [];

        grid3Api.forEachFilteredNode((node: any) => {
          if (
            node.data.nm_dummy01 !== "재단" &&
            node.data.nm_dummy01 !== "TOTAL"
          )
            allGrid3Rows.push({ ...node.data });
        });
        // 2) qt_work 합산
        //  상단 실적수량 집계가 지시/비율까지 포함되어 과대 표시된다.
        //  row_type=실적만 합산한다.
        //  실적 행만 필터링 후 qt_work 합계를 계산한다.
        const totalQtWork = allGrid3Rows
          .filter(
            (row) =>
              row.row_type === PACK_ROW_TYPE.LOCATION || row.row_type_flag === 1
          )
          .reduce((sum, row) => sum + Number(row.qt_work || 0), 0);

        // 3) grid1에서 선택된 행 가져오기
        const grid1Api = gridRefs.current["grid1"].current;
        const selectedNode = grid1Api.focusedRowNode();

        // 4) grid1 의 지시 테이블에 실적 수량 반영
        if (selectedNode) {
          selectedNode.setDataValue("qt_work", totalQtWork);
        }
      }
      // // 5) 서버에 보낼 데이터 구성
      // const prd_wo_tex = {
      //   insert: [],
      //   delete: [],
      //   update: [
      //     {
      //       cd_firm: userInfo.cd_firm,
      //       no_wo: selectedNode?.data?.no_wo,
      //       qt_work: totalQtWork,
      //     },
      //   ],
      // };

      const grid2Insert = grid2.insert ?? [];
      const grid3Insert = grid3.insert ?? [];

      const cd_module: any = Menuprops.cd_module;
      const cd_menu: any = Menuprops.cd_menu;
      let no_work_arr: any[] = [];
      let no_work_arr2: any[] = [];
      let commonNoWork: string | null = null;

      const assignSameNoWork = async (rows: any[], noWorkCollector: any[]) => {
        if (!rows.length) return;

        // 이미 no_work 있는 경우는 재사용
        const exist = rows.find((r) => String(r.no_work ?? "").trim() !== "");

        if (exist) {
          commonNoWork = exist.no_work;
        } else {
          commonNoWork = await getNoSlip(
            cd_module,
            1,
            "WRK",
            todayform,
            cd_menu
          );
        }

        if (!commonNoWork) return;

        noWorkCollector.push(commonNoWork);

        for (const row of rows) {
          row.no_work = commonNoWork;
        }
      };
      if (grid2Insert.length > 0) {
        await assignSameNoWork(grid2Insert, no_work_arr);
      }
      if (grid3Insert.length > 0) {
        await assignSameNoWork(grid3Insert, no_work_arr2);
      }
      const cd_dept = userInfo.cd_dept;
      const yn_autorcv = selectedRow.yn_autorcv;
      const cd_wh = selectedRow.cd_wh_rcv;
      const withs = (rows: any[]) =>
        rows.map((row) => ({
          ...row,
          cd_dept,
          yn_autorcv,
          cd_wh,
        }));
      const grid2Delete = await grid2.delete;
      const grid3Delete = await grid3.delete;
      const selectRow = gridRefs.current["grid1"].current.focusedRowNode();
      const no_po = selectRow?.data?.no_po;
      const mergeData = {
        insert: withs([
          ...grid2.insert,
          ...grid3.insert.map((row: any) => ({
            ...row,
            no_po,
          })),
        ]),
        update: withs([...grid2.update, ...grid3.update]),
        delete: withs([...grid2Delete, ...grid3Delete]),
      };
      SaveData = {
        prd_workvariant_tex: mergeData,
        // prd_wo_tex: prd_wo_tex,
      };

      gridRefs.current["grid2"].current.applyFilters({
        no_wo: selectRow.data?.no_wo,
      });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
      gridRefs.current["grid3"].current.applyFilters({
        no_wo: selectRow.data?.no_wo,
      });
      gridRefs.current["grid3"].current.selectAndFocusRow(0);
      await fnSave("SN_PRD_WRK_REG_002_TEX_SAVE_01", SaveData);
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      if (selectRow) {
        focusKeyRef.current = {
          no_wo: selectRow.data.no_wo,
        };
      }
      await onSearch();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();

      return false;
    }
  };
  //  저장 시 피벗(슬롯) 데이터를 롱포맷으로 변환하지 않으면 누락/불일치가 발생.
  //  qt_work1~20 슬롯을 cd_var3 기준 롱포맷으로 변환해 저장 payload를 구성.
  //  sizeSlotMapRef 매핑으로 슬롯 -> cd_var3 변환을 강제한다.
  // 피벗 슬롯(qt_work1~20)을 롱포맷 저장 구조로 변환한다.
  function buildSaveRows(
    rows: any[],
    sizeSlotMapRef: React.MutableRefObject<Map<string, string[]>>,
    includeLocation: boolean
  ) {
    const saves: any[] = [];
    const noWorkByBaseKey = new Map<string, string>();
    rows.forEach((row: any) => {
      const noWork = String(row.back_no_work ?? row.no_work ?? "").trim();
      if (!noWork) return;
      noWorkByBaseKey.set(getBaseKey(row, includeLocation), noWork);
    });
    let no_line = 1;
    rows.forEach((row: any) => {
      if (includeLocation) {
        if (row.row_type !== PACK_ROW_TYPE.LOCATION && row.row_type_flag !== 1)
          return;
      } else if (row.row_type && row.row_type !== ROW_TYPE.WORK) {
        return;
      }
      const baseKey = getBaseKey(row, includeLocation);
      const noWork =
        String(row.back_no_work ?? row.no_work ?? "").trim() ||
        noWorkByBaseKey.get(baseKey) ||
        "";
      const pivotKey = `${baseKey}|${noWork}`;
      const sizeCodes = sizeSlotMapRef.current.get(pivotKey) ?? [];

      sizeSlotColumns.forEach((slot, index) => {
        const sizeCode = sizeCodes[index];
        if (!sizeCode) return;
        const qt = Number(row[slot] ?? 0);
        if (!qt) return;
        const { yn_saved_set, __excel_batch_id, work_set_id, ...baseRow } = row;
        saves.push({
          ...baseRow,
          no_work: noWork || row.no_work,
          no_line: no_line++,
          cd_var3: sizeCode,
          qt_work: qt,
          cd_user_reg: userInfo.cd_user,
        });
      });
    });
    return saves;
  }
  async function buildDeleteRows(
    rows: any[],
    sizeSlotMapRef: React.MutableRefObject<Map<string, string[]>>,
    includeLocation: boolean
  ) {
    const deletes: any[] = [];

    const workSetIdSet = new Set<string>();
    rows.forEach((row: any) => {
      if (includeLocation && row.row_type === PACK_ROW_TYPE.TOTAL) return;
      if (!row.work_set_id) return;

      workSetIdSet.add(String(row.work_set_id));
    });

    const noLineList: string[] = [];

    for (const workSetId of workSetIdSet) {
      const payload = {
        id: "search_workvariant_tex_no_line",
        params: {
          cd_firm: userInfo.cd_firm,
          no_work: workSetId,
        },
      };

      const result = await fnGetTableById(payload);

      if (result.length > 0) {
        result.forEach((item: any) => {
          deletes.push({
            cd_firm: userInfo.cd_firm,
            no_line: item.no_line,
            no_work: workSetId,
            no_line_wo: 0,
            no_wo: rows[0].no_wo,
            cd_biz: item.cd_biz,
            dt_work: item.dt_work,
            cd_op: item.cd_op,
            qt_work: item.qt_work,
            qt_b: item.qt_b,
            cd_item: item.cd_item,
            cd_var1: item.cd_var1,
            cd_var2: item.cd_var2,
            yn_autorcv: "Y",
          });
        });
      }
    }
    return deletes;
  }
  // 삭제 대상 세트의 롱포맷 삭제 row를 생성한다.
  /* function buildDeleteRows(
    rows: any[],
    sizeSlotMapRef: React.MutableRefObject<Map<string, string[]>>,
    includeLocation: boolean
  ) {
    const deletes: any[] = [];
    const noWorkByBaseKey = new Map<string, string>();
    const targetByKey = new Map<string, any>();
    rows.forEach((row: any) => {
      if (includeLocation && row.row_type === PACK_ROW_TYPE.TOTAL) return;
      const noWork = String(row.no_work ?? row.back_no_work ?? "").trim();
      if (!noWork) return;
      noWorkByBaseKey.set(getBaseKey(row, includeLocation), noWork);
    });
    rows.forEach((row: any) => {
      if (includeLocation && row.row_type === PACK_ROW_TYPE.TOTAL) return;
      const baseKey = getBaseKey(row, includeLocation);
      const noWork =
        String(row.no_work ?? row.back_no_work ?? "").trim() ||
        noWorkByBaseKey.get(baseKey) ||
        "";
      if (!noWork) return;
      const key = `${baseKey}|${noWork}`;
      if (!targetByKey.has(key)) {
        targetByKey.set(key, { row, baseKey, noWork });
      }
    });
    targetByKey.forEach(({ row, baseKey, noWork }) => {
      const pivotKey = `${baseKey}|${noWork}`;
      const fallbackKey = `${baseKey}|`;
      const sizeCodes =
        sizeSlotMapRef.current.get(pivotKey) ??
        sizeSlotMapRef.current.get(fallbackKey) ??
        [];
      sizeSlotColumns.forEach((slot, index) => {
        const sizeCode = sizeCodes[index];
        if (!sizeCode) return;
        const { yn_saved_set, __excel_batch_id, work_set_id, ...baseRow } = row;
        deletes.push({
          ...baseRow,
          no_work: noWork,
          no_line: index + 1,
          cd_var3: sizeCode,
          qt_work: Number(row[slot] ?? 0),
        });
      });
    });
    return deletes;
  }*/

  // baseKey별 헤더(작업일/작업자) 정보를 세팅.
  const buildHeaderByBaseKey = (
    gridRef: React.RefObject<any>,
    includeLocation: boolean
  ) => {
    const headerByKey = new Map<string, any>();
    gridRef.current?.forEachFilteredNode?.((node: any) => {
      const row = node.data;
      const isHeader =
        row.row_type === ROW_TYPE.ORDER || row.row_type_flag === 0;
      if (!isHeader) return;
      const key = getBaseKey(row, includeLocation);
      headerByKey.set(key, {
        dt_work: row.dt_work,
        cd_emp: row.cd_emp,
        nm_emp: row.nm_emp,
      });
    });
    return headerByKey;
  };

  // 헤더 정보를 실적 행에 보정 적용한다.
  const applyHeaderFields = (
    rows: any[],
    headerByKey: Map<string, any>,
    includeLocation: boolean
  ) =>
    rows.map((row: any) => {
      const header = headerByKey.get(getBaseKey(row, includeLocation));
      if (!header) return row;
      return {
        ...row,
        dt_work: row.dt_work || header.dt_work,
        cd_emp: row.cd_emp || header.cd_emp,
        nm_emp: row.nm_emp || header.nm_emp,
      };
    });

  // 재단 그리드 변경분을 저장용 롱포맷으로 변환한다.
  function filterAndMapGrid(
    grid: any,
    sizeSlotMapRef: React.MutableRefObject<Map<string, string[]>>,
    includeLocation: boolean,
    gridRef: React.RefObject<any>
  ) {
    const filtered = {
      ...grid,
      insert: grid.insert.filter(
        (row: any) =>
          row.row_type === PACK_ROW_TYPE.LOCATION || row.row_type_flag === 1
      ),
      update: grid.update.filter(
        (row: any) =>
          row.row_type === PACK_ROW_TYPE.LOCATION || row.row_type_flag === 1
      ),
    };
    filtered.update = filtered.update.map((row: any) => ({
      ...row,
      cd_emp: row.back_cd_emp,
      dt_work: row.back_dt_work,
      cd_var1: row.back_cd_var1,
      cd_var2: row.back_cd_var2,
      no_work: row.back_no_work,
    }));

    filtered.insert = filtered.insert.map((row: any) => ({
      ...row,
      dt_work: row.back_dt_work ?? row.dt_work,
      cd_emp: row.back_cd_emp ?? row.cd_emp,
      cd_var1: row.back_cd_var1 ?? row.cd_var1,
      cd_var2: row.back_cd_var2 ?? row.cd_var2,
    }));

    const headerByKey = buildHeaderByBaseKey(gridRef, includeLocation);
    filtered.insert = applyHeaderFields(
      filtered.insert,
      headerByKey,
      includeLocation
    );
    filtered.update = applyHeaderFields(
      filtered.update,
      headerByKey,
      includeLocation
    );

    filtered.insert = buildSaveRows(
      filtered.insert,
      sizeSlotMapRef,
      includeLocation
    );
    filtered.update = buildSaveRows(
      filtered.update,
      sizeSlotMapRef,
      includeLocation
    );
    filtered.delete = buildDeleteRows(
      grid.delete ?? [],
      sizeSlotMapRef,
      includeLocation
    );

    filtered.modifiedRowcount =
      filtered.insert.length + filtered.update.length + filtered.delete.length;
    const hasRequired = [...filtered.insert, ...filtered.update].every(
      (row: any) =>
        (row.back_dt_work || row.dt_work) &&
        row.cd_var1 &&
        row.cd_var2 &&
        (row.back_cd_emp || row.cd_emp)
    );

    return { filtered, hasRequired };
  }

  // 포장 그리드 변경분을 저장용 롱포맷으로 변환한다.
  function filterAndMapGrid3(
    grid: any,
    sizeSlotMapRef: React.MutableRefObject<Map<string, string[]>>,
    includeLocation: boolean,
    gridRef: React.RefObject<any>
  ) {
    const filtered = {
      ...grid,
      insert: grid.insert.filter(
        (row: any) =>
          row.row_type === PACK_ROW_TYPE.LOCATION || row.row_type_flag === 1
      ),
      update: grid.update.filter(
        (row: any) =>
          row.row_type === PACK_ROW_TYPE.LOCATION || row.row_type_flag === 1
      ),
    };

    filtered.update = filtered.update.map((row: any) => ({
      ...row,
      cd_emp: row.back_cd_emp,
      dt_work: row.back_dt_work,
      cd_var1: row.back_cd_var1,
      cd_var2: row.back_cd_var2,
      no_work: row.back_no_work,
    }));

    filtered.insert = filtered.insert.map((row: any) => ({
      ...row,
      dt_work: row.back_dt_work ?? row.dt_work,
      cd_emp: row.back_cd_emp ?? row.cd_emp,
      cd_var1: row.back_cd_var1 ?? row.cd_var1,
      cd_var2: row.back_cd_var2 ?? row.cd_var2,
    }));

    const headerByKey = buildHeaderByBaseKey(gridRef, includeLocation);
    filtered.insert = applyHeaderFields(
      filtered.insert,
      headerByKey,
      includeLocation
    );
    filtered.update = applyHeaderFields(
      filtered.update,
      headerByKey,
      includeLocation
    );
    if (grid.insert.length > 0) {
      filtered.insert = buildSaveRows(
        filtered.insert,
        sizeSlotMapRef,
        includeLocation
      );
    } else if (grid.update.length > 0) {
      filtered.update = buildSaveRows(
        filtered.update,
        sizeSlotMapRef,
        includeLocation
      );
    } else if (grid.delete.length > 0) {
      filtered.delete = buildDeleteRows(
        grid.delete ?? [],
        sizeSlotMapRef,
        includeLocation
      );
    }

    filtered.modifiedRowcount =
      filtered.insert.length + filtered.update.length + filtered.delete.length;

    const hasRequired = [...filtered.insert, ...filtered.update].every(
      (row: any) =>
        (row.back_dt_work || row.dt_work) &&
        row.cd_var1 &&
        row.cd_var2 &&
        (row.back_cd_emp || row.cd_emp) &&
        row.cd_dummy01
    );

    return { filtered, hasRequired };
  }

  const onBtnsClick = async (id: string) => {
    //#region BtnaddRow
    if (id === "addRow") {
      onAddRow();
    }
    //#region BtndeleteRow
    else if (id === "deleteRow") {
      onDeleteRow();
    } else if (id === "btnRegister") {
      const focusedRowNode = gridRefs.current["grid1"].current.focusedRowNode();
      const cd_wh_rcv = focusedRowNode?.data?.cd_wh_rcv;
      const no_wo = focusedRowNode?.data?.no_wo;
      const nm_wh = focusedRowNode?.data?.nm_wh;
      const no_po = focusedRowNode?.data?.no_po;
      const yn_rcv_b = "Y";

      const selectedRow =
        gridRefs.current["grid3"].current.getSelectedRows()[0];

      const selectedNoWork = selectedRow.no_work;
      const groupedMap = new Map<string, any>();

      gridRefs.current["grid3"].current.forEachFilteredNode((node: any) => {
        const row = node.data;

        if (
          !["재단", "TOTAL"].includes(row.nm_dummy01) &&
          row.row_type !== PACK_ROW_TYPE.TOTAL &&
          String(row.cd_dummy01 ?? "")
            .trim()
            .toUpperCase() !== "TOTAL" &&
          row.no_work === selectedNoWork
        ) {
          const key = `${row.cd_var1}|${row.cd_var2}`;

          // 👉 이미 있으면 스킵 (or 합산 가능)
          if (!groupedMap.has(key)) {
            groupedMap.set(key, row);
          }
        }
      });

      const selectedData = Array.from(groupedMap.values());
      if (selectedData.length === 0) {
        showDialog("alter", "실적번호를 선택해주세요.");
        return;
      }
      const component = (
        <SN_PRD_WRK_REG_002_TEX_POP_001
          selectedDataList={selectedData}
          selectedData={{
            cd_wh_rcv: cd_wh_rcv,
            nm_wh: nm_wh,
            yn_rcv_b: yn_rcv_b,
            no_po: no_po,
            no_wo: no_wo,
          }}
        />
      );
      const result = await showPopupModal({
        title: "불량내역",
        children: component,
        validation: true,
        width: "69%",
        height: "70%",
        okayBtn: true,
        closeBtn: true,
      });
      if (!result || result === "close") return;
      if (focusedRowNode) {
        focusKeyRef.current = {
          no_wo: no_wo,
        };
      }
      await onSearch();
      const updates = result[0].update ?? [];
    } else if (id === "btnReqMatIn") {
      const focusedRowNode = gridRefs.current["grid1"].current.focusedRowNode();
      const focusedLineRowNode =
        gridRefs.current["grid2"].current.focusedRowNode();
      if (focusedLineRowNode.data.row_type !== "수주") {
        showDialog("alter", "실적번호를 선택해주세요.");
        return;
      }
      let orderRowData: any = null;
      let totalQtWork = 0;
      gridRefs.current["grid2"].current.forEachFilteredNode((node: any) => {
        if (!node.data) return;
        if (
          node.data.work_set_id === focusedLineRowNode.data.work_set_id &&
          node.data.row_type === "실적"
        ) {
          totalQtWork += Number(node.data.qt_work ?? 0);
        }
        if (
          node.data.work_set_id === focusedLineRowNode.data.work_set_id &&
          node.data.row_type === ROW_TYPE.ORDER
        ) {
          orderRowData = node.data;
        }
      });

      const dt_work = orderRowData?.dt_work;

      const selectedData = {
        no_po: focusedRowNode.data.no_po,
        no_wo: focusedRowNode.data.no_wo,
        no_style: focusedRowNode.data.no_style,
        cd_wh: focusedRowNode.data.cd_wh_rcv,
        qt_work: String(totalQtWork),
        no_io: focusedLineRowNode.data.work_set_id,
        cd_biz: focusedLineRowNode.data.cd_biz,
        cd_dept: focusedLineRowNode.data.cd_dept,
        cd_emp: focusedLineRowNode.data.cd_emp,
        cd_gp: focusedLineRowNode.data.cd_gp,
        dt_io: dt_work,
        nm_wh: focusedRowNode.data.nm_wh,
        yn_isu: "Y",
      };
      const component = (
        <SN_PRD_WRK_REG_002_TEX_POP_003 selectedData={selectedData} />
      );
      const result = await showPopupModal({
        title: "소요자재등록",
        children: component,
        validation: true,
        width: "69%",
        height: "70%",
        okayBtn: true,
        closeBtn: true,
      });
      if (!result || result === "close") return;
      if (focusedRowNode) {
        focusKeyRef.current = {
          no_wo: focusedRowNode.data.no_wo,
        };
      }
      await onSearch();
    } else if (id === "btnReqMatRead") {
      const focusedRowNode = gridRefs.current["grid1"].current.focusedRowNode();
      const focusedLineRowNode =
        gridRefs.current["grid2"].current.focusedRowNode();
      if (focusedLineRowNode.data.row_type !== "수주") {
        showDialog("alter", "실적번호를 선택해주세요.");
        return;
      }
      let orderRowData: any = null;

      gridRefs.current["grid2"].current.forEachFilteredNode((node: any) => {
        if (!node.data) return;

        if (
          node.data.work_set_id === focusedLineRowNode.data.work_set_id &&
          node.data.row_type === ROW_TYPE.ORDER
        ) {
          orderRowData = node.data;
        }
      });

      const dt_work = orderRowData?.dt_work;

      const selectedData = {
        no_po: focusedRowNode.data.no_po,
        no_wo: focusedRowNode.data.no_wo,
        no_style: focusedRowNode.data.no_style,
        cd_wh: focusedRowNode.data.cd_wh_rcv,
        qt_work: String(focusedLineRowNode.data.qt_work),
        no_io: focusedLineRowNode.data.work_set_id,
        cd_biz: focusedLineRowNode.data.cd_biz,
        cd_dept: focusedLineRowNode.data.cd_dept,
        cd_emp: focusedLineRowNode.data.cd_emp,
        cd_gp: focusedLineRowNode.data.cd_gp,
        dt_io: dt_work,
        nm_wh: focusedRowNode.data.nm_wh,
        yn_isu: "Y",
      };
      const component = (
        <SN_PRD_WRK_REG_002_TEX_POP_004 selectedData={selectedData} />
      );
      const result = await showPopupModal({
        title: "소요자재현황",
        children: component,
        validation: false,
        width: "69%",
        height: "70%",
        okayBtn: true,
        closeBtn: true,
      });
      if (!result || result === "close") return;
    }
  };

  //#region Filter
  const onFocusedRowChanged = async (event: any) => {
    //  상단 선택 변경 시 BE 재호출 없이 캐시 데이터를 피벗으로 재구성해야 한다.
    //  캐시된 롱포맷을 기준으로 피벗 3행을 재구성하고 컬럼/필터를 갱신한다.
    //  cut/pack 캐시를 피벗 변환 후 즉시 그리드에 반영한다.
    const selectedRow = event;
    if (!selectedRow) return;

    const no_wo = selectedRow.no_wo;
    setSelectedDocu(no_wo);
    setSelectedLineDocu(selectedRow.no_line_wo ?? 0);
    //  no_work가 없는 신규 세트가 필터에서 제외되어 합쳐진다.
    //  no_work 또는 work_set_id 기준으로 필터링한다.
    //  세트 식별 키를 둘 중 하나로 인정한다.
    const cutRows = cutLongRowsRef.current.filter(
      (row: any) =>
        row.no_wo === no_wo &&
        !!(row.no_work || row.work_set_id) &&
        (selectedRow.no_line_wo
          ? row.no_line_wo === selectedRow.no_line_wo
          : true)
    );
    const packLocationBaseKeys = new Set<string>();
    packLongRowsRef.current.forEach((row: any) => {
      if (row.no_wo !== no_wo) return;
      if (selectedRow.no_line_wo && row.no_line_wo !== selectedRow.no_line_wo)
        return;
      if (
        String(row.cd_dummy01 ?? "")
          .trim()
          .toUpperCase() === "TOTAL"
      ) {
        return;
      }
      const hasSetKey = !!(row.no_work || row.work_set_id);
      if (!hasSetKey) return;
      const baseKey = getBaseKey(row, false);
      packLocationBaseKeys.add(baseKey);
    });
    const packRows = packLongRowsRef.current.filter((row: any) => {
      if (row.no_wo !== no_wo) return false;
      if (selectedRow.no_line_wo && row.no_line_wo !== selectedRow.no_line_wo)
        return false;
      const isTotal =
        String(row.cd_dummy01 ?? "")
          .trim()
          .toUpperCase() === "TOTAL";
      if (isTotal && !packLocationBaseKeys.has(getBaseKey(row, false)))
        return false;
      const hasSetKey = !!(row.no_work || row.work_set_id) || isTotal;
      return hasSetKey;
    });

    const cutPivot = buildPivotRows({
      rows: cutRows,
      includeLocation: false,
      sizeSlotMapRef: cutSizeSlotMapRef,
    });
    const packPivot = buildPivotRows({
      rows: packRows,
      includeLocation: true,
      sizeSlotMapRef: packSizeSlotMapRef,
    });
    setDataSources((prev: any) => ({
      ...prev,
      grid2: sortPivotRows(cutPivot.pivotRows),
      grid3: sortPivotRows(packPivot.pivotRows),
    }));

    const cutVirtual = buildSizeColumnUpdates(
      columns.grid2,
      cutPivot.slotLabelByColumn
    );
    const packVirtual = buildSizeColumnUpdates(
      columns.grid3,
      packPivot.slotLabelByColumn
    );
    applySizeColumnState("grid2", cutPivot.slotLabelByColumn);
    applySizeColumnState("grid3", packPivot.slotLabelByColumn);
    gridRefs.current["grid2"].current.changeColumnConfigs(
      cutVirtual.length > 0 ? cutVirtual : visible
    );
    gridRefs.current["grid3"].current.changeColumnConfigs(
      packVirtual.length > 0 ? packVirtual : visible
    );

    gridRefs.current["grid2"].current.applyFilters({ no_wo: no_wo });
    gridRefs.current["grid2"].current.selectAndFocusRow(0);
    gridRefs.current["grid3"].current.applyFilters({ no_wo: no_wo });
    gridRefs.current["grid3"].current.selectAndFocusRow(0);
  };

  //#region cellChanged

  const getWorkSetKey = (row: any) => {
    const noWork = String(row?.no_work ?? "").trim();
    if (noWork) {
      return { type: "no_work", value: noWork };
    }
    return { type: "empty_no_work", value: "" };
  };

  const isSameWorkSet = (row: any, setKey: { type: string; value: string }) => {
    const noWork = String(row?.no_work ?? "").trim();
    if (setKey.type === "no_work") {
      return noWork === setKey.value;
    }
    return !noWork;
  };

  const isDtWorkDisplayRow = (gridKey: "grid2" | "grid3", row: any) =>
    gridKey === "grid2"
      ? row.row_type === ROW_TYPE.ORDER || row.row_type_flag === 0
      : row.row_type === PACK_ROW_TYPE.LOCATION || row.row_type_flag === 1;

  const syncDtWorkWithinGridSet = (
    gridKey: "grid2" | "grid3",
    sourceRow: any,
    dtWork: any
  ) => {
    const setKey = getWorkSetKey(sourceRow);
    if (!setKey) return;

    const isSaveTarget =
      gridKey === "grid2"
        ? (row: any) =>
            row.row_type === ROW_TYPE.WORK || row.row_type_flag === 1
        : (row: any) =>
            row.row_type === PACK_ROW_TYPE.LOCATION || row.row_type_flag === 1;

    gridRefs.current[gridKey].current?.forEachFilteredNode((node: any) => {
      if (!node?.data || !isSameWorkSet(node.data, setKey)) return;

      if (
        isDtWorkDisplayRow(gridKey, node.data) &&
        node.data.dt_work !== dtWork
      ) {
        node.setDataValue("dt_work", dtWork, "noEvent");
      }
      if (!isSaveTarget(node.data)) return;

      const backNoWork = setKey.type === "no_work" ? setKey.value : "";
      node.setDataValue("back_no_work", backNoWork);
      node.setDataValue("back_dt_work", dtWork);
      node.setDataValue("back_cd_emp", node.data.cd_emp);
      node.setDataValue("back_cd_var1", node.data.cd_var1);
      node.setDataValue("back_cd_var2", node.data.cd_var2);
    });
  };

  // 실적 수량 입력 시 비율 행을 재계산하고 헤더 값 백업을 기록한다.
  const onCellValueChanged2 = async (event: any) => {
    if (!event) return;
    const updatedRow = event.rowData;
    const updatedColumnId = event.colId;
    if (updatedColumnId === "dt_work") {
      syncDtWorkWithinGridSet("grid2", updatedRow, updatedRow.dt_work);
      return;
    }
    const isWorkRow =
      updatedRow.row_type === ROW_TYPE.WORK || updatedRow.row_type_flag === 1;
    if (!isWorkRow) return;
    if (!sizeSlotColumns.includes(updatedColumnId)) return;
    if (updatedRow.yn_saved_set === 1) {
      showDialog("alter", "저장된 세트는 수정할 수 없습니다.");
      event.rowNode?.setDataValue(
        updatedColumnId,
        event.oldValue ?? 0,
        "noEvent"
      );
      return;
    }

    const rowNode = gridRefs.current["grid2"].current.getRowNodeAtIndex(
      event.rowIndex - 1
    );
    const rowNode2 = gridRefs.current["grid2"].current.getRowNodeAtIndex(
      event.rowIndex + 1
    );
    if (!rowNode || !rowNode2) return;

    let qt = 0;
    sizeSlotColumns.forEach((slot) => {
      const orderValue = Number(rowNode.data[slot] || 0);
      const workValue = Number(updatedRow[slot] || 0);
      const rateValue =
        orderValue > 0
          ? Math.round(((workValue - orderValue) * 100) / orderValue)
          : 0;
      rowNode2.setDataValue(slot, rateValue);
      qt += workValue;
    });

    event.rowNode.setDataValue("back_no_work", updatedRow.no_work);
    event.rowNode.setDataValue("back_dt_work", updatedRow.dt_work);
    event.rowNode.setDataValue("back_cd_emp", updatedRow.cd_emp);
    event.rowNode.setDataValue("back_cd_var1", updatedRow.cd_var1);
    event.rowNode.setDataValue("back_cd_var2", updatedRow.cd_var2);
    event.rowNode.setDataValue("qt_work", qt);
  };

  // 실적 수량 입력 시 비율 행을 재계산하고 헤더 값 백업을 기록한다.
  const onCellValueChanged3 = async (event: any) => {
    if (!event) return;
    const updatedRow = event.rowData;
    const updatedColumnId = event.colId;
    if (updatedColumnId === "dt_work") {
      syncDtWorkWithinGridSet("grid3", updatedRow, updatedRow.dt_work);
      return;
    }
    const isLocationRow =
      updatedRow.row_type === PACK_ROW_TYPE.LOCATION ||
      updatedRow.row_type_flag === 1;
    if (!isLocationRow) return;
    if (!sizeSlotColumns.includes(updatedColumnId)) return;
    if (updatedRow.yn_saved_set === 1) {
      showDialog("alter", "저장된 세트는 수정할 수 없습니다.");
      event.rowNode?.setDataValue(
        updatedColumnId,
        event.oldValue ?? 0,
        "noEvent"
      );
      return;
    }

    let qt = 0;
    sizeSlotColumns.forEach((slot) => {
      const workValue = Number(updatedRow[slot] || 0);
      qt += workValue;
    });

    event.rowNode.setDataValue("back_no_work", updatedRow.no_work);
    event.rowNode.setDataValue("back_dt_work", updatedRow.dt_work);
    event.rowNode.setDataValue("back_cd_emp", updatedRow.cd_emp);
    event.rowNode.setDataValue("back_cd_var1", updatedRow.cd_var1);
    event.rowNode.setDataValue("back_cd_var2", updatedRow.cd_var2);
    event.rowNode.setDataValue("qt_work", qt);
  };
  const onRowDataReady = () => {
    const focusKey = focusKeyRef.current;
    if (!focusKey) return;

    const grid = gridRefs.current["grid1"].current;

    const rowCount = grid.getDisplayedRowCount();
    let targetIndex = -1;

    for (let i = 0; i < rowCount; i++) {
      const rowNode = grid.getRowNodeAtIndex(i);
      if (!rowNode?.data) continue;

      if (rowNode.data.no_wo === focusKey.no_wo) {
        targetIndex = i;
        break;
      }
    }

    if (targetIndex >= 0) {
      grid.selectAndFocusRow(targetIndex);
      grid.scrollToIndex?.(targetIndex);
    } else {
      grid.selectAndFocusRow(0);
    }

    focusKeyRef.current = null;
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
          onRowDataReady: onRowDataReady,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onCellValueChanged: onCellValueChanged2,
          getContextMenuItems: getExcelContextMenuItems,
          sumRowFilter: (row: any) => {
            const flag = Number(row.row_type_flag);
            if (flag === 1) return true;
            const rowType = String(row.row_type ?? "").trim();
            return (
              rowType === String(ROW_TYPE.WORK).trim() ||
              rowType === "실적" ||
              rowType.toUpperCase() === "WORK"
            );
          },
        },
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
        events: {
          onCellValueChanged: onCellValueChanged3,
          getContextMenuItems: getExcelContextMenuItems,
          sumRowFilter: (row: any) => {
            const flag = Number(row.row_type_flag);
            if (flag === 1) return true;
            const rowType = String(row.row_type ?? "").trim();
            return (
              rowType === String(PACK_ROW_TYPE.LOCATION).trim() ||
              rowType.toUpperCase() === "LOCATION"
            );
          },
        },
      },
      sheet1: {
        columns: columns.sheet1,
        dataSource: dataSources.sheet1,
      },
    }),
    [columns, dataSources]
  );

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        />
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{ rowSelection: "single", title: "작업지시" }}
            events={grids.grid1.events}
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnTab
            titles={["재단", "포장"]}
            width={"100%"}
            selectedTab={tab}
            onTabChanged={(index: any) => {
              setTab(index);
              selectedTabPage.current = index;
            }}
            header={[
              <SnTabHeader
                onBtnAddClick={onBtnsClick}
                onBtnDeleteClick={onBtnsClick}
                body={
                  <div className="relative flex space-x-2">
                    <SnButton
                      text={"소요자재등록"}
                      onClick={() => {
                        onBtnsClick("btnReqMatIn");
                      }}
                    />

                    <SnButton
                      text={"소요자재현황"}
                      onClick={() => {
                        onBtnsClick("btnReqMatRead");
                      }}
                    />
                  </div>
                }
              />,

              <SnTabHeader
                body={
                  <div className="relative flex space-x-2">
                    <SnButton
                      text={"불량내역등록"}
                      onClick={() => {
                        onBtnsClick("btnRegister");
                      }}
                    />
                  </div>
                }
                onBtnAddClick={onBtnsClick}
                onBtnDeleteClick={onBtnsClick}
              />,
            ]}
            body={[
              <SnGrid
                ref={gridRefs.current["grid2"]} // Grid Name
                columnConfig={grids.grid2.columns} // 컬럼 설정 전달
                rowData={grids.grid2.dataSource} // Datasource
                etcProps={{ rowSelection: "single", enableInitialSort: false }}
                events={grids.grid2.events}
              />,

              <SnGrid
                ref={gridRefs.current["grid3"]} // Grid Name
                columnConfig={grids.grid3.columns} // 컬럼 설정 전달
                rowData={grids.grid3.dataSource} // Datasource
                etcProps={{ rowSelection: "single", enableInitialSort: false }}
                events={grids.grid3.events}
              />,
              <div style={{ display: "none" }}>
                <SnGrid
                  ref={sheetref1} // Grid Name
                  columnConfig={grids.sheet1.columns} // 컬럼 설정 전달
                  rowData={grids.sheet1.dataSource} // Datasource
                />
              </div>,
            ]}
          />
        </SnResizeBar>
        <SnFileUploadBox
          selectedDocu={selectedDocu}
          selectedLineDocu={selectedLineDocu}
        />
      </div>
    </div>
  );
  //#endregion
});

export default SN_PRD_WRK_REG_002_TEX;
